import {
  AddUserGroup,
  User,
  UserRole,
  Person,
  ContactGroup,
  Policy,
  EmailMonitor,
  Page,
  MobileDevice,
  Calendar,
  CalendarAclResource,
  AppPassword,
  ThirdPartyApp,
  UserSettings,
  ReportModel,
  LabelModel,
  DelegateModel,
  ForwardingAddressModel,
  ForwardingModel,
  PopSettingsModel,
  Doc,
  Folder,
  Group,
  GroupHealthSummary,
  GroupHealthSettings,
  WelcomeTemplateEntity,
  UserListEntity,
  ImapSettingsModel,
  SendAsModel,
  VacationModel,
  TransferOwnershipModel,
  FilterModel,
  SignatureModel,
  AppLogSearch,
  AppLog,
  GPanelPermissionsModel,
  GmailPopModel,
  SignaturePopulationResponse,
  SignatureRequestBody,
  CustomSchemaEntity,
  SharedDriveModel,
  DirectoryGroup,
  GroupTemplate,
  GroupBusinessSettings,
  DirectoryGroupMember,
  SharedContactModel,
  ContactSyncModel,
  OrgUnitModel,
  ContactSyncUserModels,
  ContactSyncRunLog,
  UserSearchFilter,
  DataTransferLog,
  CustomLogoSetup,
  ResourceTemplateModel,
  BuildingsModel,
  ResourceCalendar,
  FeatureModel,
  CalendarSearch,
  CalendarEventModel,
  DocSearchFilter,
  DriveSweepModel,
  ChromeDeviceModel,
  FirebaseUserModel,
  ViewType,
  MobileDeviceAction,
  ChromeOsMoveDevicesToOuModel,
  ActivityModel,
  ReactSearchResult,
  GmailDeletionModel,
  GmailAuditModel,
  GmailExportKey,
  BulkImportModel,
  ReportType,
  BulkImportType,
  ApigeeApp,
  FeatureEntity,
  SignatureRunLog,
  IpIntrusionRule,
  IP_Settings,
  SpreadsheetLinesResult,
  ErrorType,
  RoleMember,
  RoleMemberType,
  SecondaryDomainModel,
  BulkAddSecondaryDomainsResponse,
  ResourceCalendarDefault,
  IndexUserLog,
  IndexGroupLog,
  IndexCalendarLog,
  IndexOrgLog,
  DecomModel,
  UserSearchEntity,
  DecomLogModel,
  MarketingOverviewModel,
  DecomSuspendedUserModel,
  TrialUserModel,
  DriveMonitorJobLog,
  ExpiringGmailDelegate,
  EmailQueueModel,
  AuthResponse,
  MobileSearchFilter,
  BigQueryPage,
  GroupSecuritySettingsModel,
  CloudIdentityGroupRolesUpdateModel,
  CloneGroupRequest,
  BulkOperationResponse,
  TemplateGenerationRequest,
  DocLocation,
  MailIdModel,
  ScheduledUserStatusUpdate,
  PinAction,
  SlackConnectionStatus,
} from '../../types';
import qs from 'qs';
import { FormPerson } from '../components/user-management/user-details/personal-contacts/edit-personal-contact';
import { cPanelLogSearchForm } from '../components/report-center/cPanelLog-grid';
import { queryOptions } from '@tanstack/react-query';
import { Messages } from '../utils/message-constants';
import { GridFilterModel, GridSortModel } from '@mui/x-data-grid-pro';
import instance from './axios-instance';
// import { admin_directory_v1 } from '@googleapis/admin';
// import { drive_v3 } from '@googleapis/drive';
import { cloudidentity_v1 } from '@googleapis/cloudidentity';
import type { drivelabels_v2 } from '@googleapis/drivelabels';
import { FormValue } from '../components/calendars/resource-templates/resource-templates-form-page';

export const UserKeys = {
  Auth: 'Auth',
  UserSettings: 'UserSettings',
  OmniSearchResults: 'OmniSearchResults',
  UserPortalSettings: 'UserPortalSettings',
  UserPortalDirectorySearch: 'UserPortalDirectorySearch',
  UserList: 'UserList',
  User: 'User',
  UserNameAvailability: 'UserNameAvailability',
  UserPortal: 'UserPortal',
  UserPhoto: 'UserPhoto',
  UserPhotoPortal: 'UserPhotoPortal',
  UserStorage: 'UserStorage',
  UserRole: 'UserRole',
  OrgUnitModels: 'OrgUnitModels',
  OrgUnitUsers: 'OrgUnitUsers',
  Domains: 'Domains',
  DirectoryGroup: 'DirectoryGroup',
  Groups: 'Groups',
  GroupCount: 'GroupCount',
  gPanelRoles: 'gPanelRoles',
  gPanelRole: 'gPanelRole',
  EmailTemplates: 'emailTemplates',
  ContactGroup: 'ContactGroup',
  Contacts: 'Contacts',
  ContactSearch: 'ContactSearch',
  Labels: 'Labels',
  Policies: 'Policies',
  PolicyCount: 'PolicyCount',
  PolicyActions: 'PolicyActions',
  UserGroups: 'UserGroups',
  EmailMonitors: 'EmailMonitors',
  Devices: 'Devices',
  CalendarSearch: 'CalendarSearch',
  Calendars: 'Calendars',
  CalendarEvent: 'CalendarEvent',
  CalendarEvents: 'CalendarEvents',
  CalendarAcls: 'CalendarAcls',
  AppPasswords: 'AppPasswords',
  ThirdPartyApps: 'ThirdPartyApps',
  DriveRootId: 'DriveRootId',
  DriveFolders: 'DriveFolders',
  DriveFoldersForOwnedByMe: 'DriveFoldersForOwnedByMe',
  DriveFolder: 'DriveFolder',
  DriveDocuments: 'DriveDocuments',
  DriveAcls: 'DriveAcls',
  DrivePermissions: 'DrivePermissions',
  SharedDrivesForUser: 'SharedDrivesForUser',
  SharedDrivesForDomain: 'SharedDrivesForDomain',
  SharedDrivesForDomainPage: 'SharedDrivesForDomainPage',
  SharedDrivesIndexedPage: 'SharedDriveIndexedPage',
  SharedDrive: 'SharedDrive',
  SharedDriveFolders: 'SharedDriveFolders',
  SharedDriveDocuments: 'SharedDriveDocuments',
  SharedDriveUserPermission: 'SharedDriveUserPermission',
  DriveTransferLogs: 'DriveTransferLogs',
  DriveLabels: 'DriveLabels',
  GmailLabels: 'GmailLabels',
  AccountDelegates: 'AccountDelegates',
  ExpiringGmailDelegates: 'ExpiringGmailDelegates',
  ForwardingAddresses: 'ForwardingAddresses',
  ImapSettings: 'ImapSettings',
  GmailForwarding: 'GmailForwarding',
  GmailPopSettings: 'GmailPopSettings',
  SendAsAccounts: 'SendAsAccounts',
  VacationMessage: 'VacationMessage',
  Signatures: 'Signatures',
  AppLogs: 'AppLogs',
  SignatureValue: 'SignatureValue',
  CustomSchemas: 'CustomSchemas',
  CheckIfInGlobalBlockList: 'CheckIfInGlobalBlockList',
  GroupTemplates: 'GroupTemplates',
  DirectoryGroupPage: 'DirectoryGroup',
  GroupSettings: 'GroupSettings',
  GroupSecuritySettings: 'GroupSecuritySettings',
  GroupLabels: 'GroupLabels',
  IsUserOwnerOfGroup: 'IsUserOwner',
  IsUserManagerOfGroup: 'IsUserManagerOfGroup',
  IsUserMemberOfGroup: 'IsUserMemberOfGroup',
  GroupMembers: 'GroupMembers',
  SelectedGroup: 'SelectedGroup',
  CloneDropDown: 'CloneDropDown',
  BulkAddGroupSelection: 'BulkAddGroupSelection',
  GroupAppLogs: 'GroupAppLogs',
  SharedContacts: 'SharedContacts',
  ContactSyncs: 'ContactSyncs',
  ContactSyncGroupLabels: 'ContactSyncGroupLabels',
  ContactSyncUserModels: 'ContactSyncUserModels',
  ContactSyncRunLogs: 'ContactSyncRunLogs',
  CalendarsTransferLogs: 'CalendarsTransferLogs',
  CalendarResourceTemplates: 'CalendarResourceTemplates',
  CalendarResourceTemplatesCount: 'CalendarResourceTemplatesCount',
  BuildingsList: 'BuildingsList',
  ResourceCalendars: 'ResourceCalendars',
  Features: 'Features',
  ResourceCalendarAcls: 'ResourceCalendarAcls',
  CalendarAppLogs: 'CalendarAppLogs',
  DriveSweepModels: 'DriveSweepModels',
  DriveSweepLogs: 'DriveSweepLogs',
  ChromeDevices: 'ChromeDevices',
  DecomStatus: 'DecomStatus',
  CPanelLogs: 'CPanelLogs',
  GmailDeletionModels: 'GmailDeletionModels',
  AccessToken: 'AccessToken',
  GmailAuditModels: 'GmailAuditModels',
  GmailExportKey: 'GmailExportKey',
  GmailExportDeprecationStatus: 'GmailExportDeprecationStatus',
  TagModels: 'TagModels',
  ContactListModel: 'ContactListModel',
  ContactListModels: 'ContactListModels',
  GmailFilters: 'GmailFilters',
  Contact: 'Contact',
  Reports: 'Reports',
  BulkOps: 'BulkOps',
  BulkOpsTypes: 'BulkOpsTypes',
  SpreadsheetLines: 'SpreadsheetLines',
  ReportTypes: 'ReportTypes',
  ApigeeApps: 'ApigeeApps',
  ApigeePortalLink: 'ApigeePortalLink',
  FeatureEntities: 'FeatureEntities',
  SignatureRunLogs: 'SignatureRunLogs',
  IpIntrusionSettings: 'IpIntrusionSettings',
  Timezone: 'Timezone',
  SlackUserToken: 'SlackUserToken',
  SlackConnection: 'SlackConnection',
  SlackChannels: 'SlackChannels',
  Roles: 'Roles',
  SessionTimeout: 'SessionTimeout',
  AdminApiSettings: 'AdminApiSettings',
  UserApiSettings: 'UserApiSettings',
  RoleMembers: 'RoleMembers',
  RoleMembersRole: 'RoleMembersRole',
  UserRoleAssignments: 'UserRoleAssignments',
  RoleAppLogs: 'RoleAppLogs',
  ResourceCalendarDefaults: 'ResourceCalendarDefaults',
  AllPossibleDomains: 'AllPossibleDomains',
  SecondaryDomains: 'SecondaryDomains',
  UsersRole: 'UsersRole',
  AllUsersCount: 'AllUsersCount',
  UserCountByDomain: 'UserCountByDomain',
  AllGroupsCount: 'AllGroupsCount',
  AllCalendarsCount: 'AllCalendarsCount',
  AllOrgsCount: 'AllOrgsCount',
  IndexUserLog: 'IndexUserLog',
  IndexGroupLog: 'IndexGroupLog',
  IndexCalendarLog: 'IndexCalendarLog',
  IndexOrgLog: 'IndexOrgLog',
  DecomModels: 'DecomModels',
  SuspendedUsers: 'SuspendedUsers',
  DecomLogs: 'DecomLogs',
  MarketingOverviewModels: 'MarketingOverviewModels',
  AdminView: 'AdminView',
  TrialUserEmails: 'TrialUserEmails',
  GroupRole: 'GroupRole',
  SearchedMobileDevices: 'SearchedMobileDevices',
  MobileDevicesForDomainPage: 'MobileDevicesForDomainPage',
  MobileDevicesIndexedPage: 'MobileDevicesIndexedPage',
  ChromeDevicesPage: 'ChromeDevicesPage',
  GroupsIndexedPage: 'GroupsIndexedPage',
  GroupHealthSummary: 'GroupHealthSummary',
  GroupHealthSettings: 'GroupHealthSettings',
  OrganizationsAutocomplete: 'OrganizationsAutocomplete',
  SharedDrivesAutocomplete: 'SharedDrivesAutocomplete',
  GroupsAutocomplete: 'GroupsAutocomplete',
  UsersIndexedPage: 'UsersIndexedPage',
  GroupMembersCloudIdentity: 'GroupMembersCloudIdentity',
  AdminLabsPage: 'AdminLabsPage',
  OrgUnitsFromGoogle: 'OrgUnitsFromGoogle',
  UserMails: 'UserMails',
  ScheduledUserStatusUpdate: 'ScheduledUserStatusUpdate',
};

export async function checkAuth(idToken: string, googleToken: string) {
  const res = await instance.get<AuthResponse>('/api/auth/checkAuth', {
    headers: {
      Authorization: `Bearer ${idToken}`,
      'GPanel-Google-Token': googleToken,
    },
  });
  return res.data;
}

// Deletes the signed-in Google user's Firebase login record so their next login starts fresh.
// Content-Type is set because axios defaults POST bodies to form-urlencoded.
export async function clearStaleFirebaseUser(googleIdToken: string) {
  await instance.post('/api/firebaseCleanup/clearStaleUser', googleIdToken, {
    headers: { 'Content-Type': 'text/plain' },
  });
}

export const checkAuthQuery = (
  idToken: string = '',
  googleToken: string = ''
) =>
  queryOptions({
    queryKey: [UserKeys.Auth],
    queryFn: () => checkAuth(idToken, googleToken),
    staleTime: 1000 * 5,
  });

export async function getUserSettings() {
  const res = await instance.get<UserSettings>(`/api/greeting/userSettings`);
  return res.data;
}

export const userSettingsQuery = () =>
  queryOptions({
    queryKey: [UserKeys.UserSettings],
    queryFn: () => getUserSettings(),
    refetchInterval: 1000 * 60 * 1,
    refetchIntervalInBackground: true,
    meta: {
      errorMessage: 'Session expired',
    },
  });

export async function getUserPhoto(userEmail: string) {
  const response = await instance.get<Blob>(`/api/users/${userEmail}/photo`, {
    responseType: 'blob',
  });

  if (response.status === 204) {
    return '';
  }

  return new Promise<string>((resolve) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result as string);
    reader.readAsDataURL(response.data);
  });
}

export async function getUserPhotoPortal(userEmail: string) {
  const response = await instance.get<Blob>(
    `/api/userPortal/users/${userEmail}/photo`,
    {
      responseType: 'blob',
    }
  );
  if (response.status === 204) {
    return '';
  }

  return new Promise<string>((resolve) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result as string);
    reader.readAsDataURL(response.data);
  });
}

// export async function getUsersByEmail(searchString: string) {
//   const res = await instance.get<admin_directory_v1.Schema$User[]>(
//     `/api/search/directoryUserSearch`,
//     {
//       params: {
//         partialEmail: searchString,
//       },
//     }
//   );
//   return res.data;
// }

export async function getUserPortalSettingsForAdmin() {
  const res = await instance.get<CustomLogoSetup>(
    `/api/greeting/getCustomLogoUrl`
  );
  return res.data;
}

export async function getUserPortalSettingsForUser() {
  const res = await instance.get<CustomLogoSetup>(
    `/api/greeting/getCustomLogoUrlForUser`
  );
  return res.data;
}

export function getUserPortalSettingsForUserQuery(enabled: boolean) {
  return queryOptions({
    queryKey: [UserKeys.UserPortalSettings],
    queryFn: () => getUserPortalSettingsForUser(),
    enabled,
  });
}

export async function setCustomLogoUrl(
  url: string,
  darkModeUrl: string,
  colorHex: string,
  changeLogMessage: string
) {
  const res = await instance.put<void>('/api/greeting/setCustomLogoUrl', null, {
    params: {
      url,
      darkModeUrl,
      colorHex,
      changeLogMessage,
    },
  });
  return res.data;
}

export async function saveViewType(viewType: ViewType) {
  const res = await instance.post<void>(`/api/greeting/saveViewType`, viewType);
  return res.data;
}

export async function getFirebaseUser(user: Partial<FirebaseUserModel>) {
  const res = await instance.post<FirebaseUserModel>(
    `/api/firebase/getFirebaseUser`,
    user
  );
  return res.data;
}

export async function getLogoutUrl() {
  const res = await instance.delete<string>(`/api/greeting/logout`);
  return res.data;
}

export async function storeFirebaseUser(user: FirebaseUserModel) {
  const res = await instance.put<FirebaseUserModel>(
    `/api/firebase/storeFirebaseUser`,
    user
  );
  return res.data;
}

export async function deleteFirebaseUser(user: FirebaseUserModel) {
  const res = await instance.delete<void>(`/api/firebase/deleteFirebaseUser`, {
    data: user,
  });
  return res.data;
}

export async function getUserList(
  body: Page<UserListEntity[]>,
  queryString: string,
  statusName: string,
  column: string | null,
  sortDirection: string | null
) {
  const res = await instance.post<Page<UserListEntity[]>>(
    `/api/search/userList`,
    body,
    {
      params: { queryString, statusName, column, sortDirection },
    }
  );
  return res.data;
}

export async function searchUserDirectoryByPartialEmail(partialEmail: string) {
  const res = await instance.get<User[]>(`/api/search/directoryUserSearch`, {
    params: { partialEmail },
  });
  return res.data;
}

export async function getOmniSearch(text: string) {
  const res = await instance.get<ReactSearchResult>(
    `/api/search/searchForReactOmni`,
    {
      params: { text },
    }
  );
  return res.data;
}

export async function getOmniSearchEnterprise(text: string) {
  const res = await instance.get<ReactSearchResult>(
    `/api/search/searchForReactOmniEnterprise`,
    {
      params: { text },
    }
  );
  return res.data;
}

export async function getUser(userEmail: string) {
  const res = await instance.get<User>(`/api/users/${userEmail}`);
  return res.data;
}

export async function getUserPortal(userEmail: string) {
  const res = await instance.get<User>(`/api/userPortal/users/${userEmail}`);
  return res.data;
}

export function getUserQuery(userEmail: string, isUserPortal?: boolean) {
  return queryOptions({
    queryKey: [isUserPortal ? UserKeys.UserPortal : UserKeys.User, userEmail],
    queryFn: () =>
      isUserPortal ? getUserPortal(userEmail) : getUser(userEmail),
    meta: {
      errorMessage: Messages.Errors.Network.Loading('the user'),
    },
  });
}

export async function getUserPortalUser(userEmail: string) {
  const res = await instance.get<User>(`/api/userPortal/users/getUser`, {
    params: { userEmail },
  });
  return res.data;
}

export async function getUserStorageDetails(userEmail: string) {
  const res = await instance.get<User>(`/api/users/storage/${userEmail}`);
  return res.data;
}

export async function getAllGPanelRoles() {
  const res = await instance.get<string[]>(`/api/users/roles`);
  return res.data;
}

export async function getUserGPanelRole(userEmail: string) {
  const res = await instance.get<string>(`/api/users/${userEmail}/roles`);
  return res.data;
}

export function getUserGPanelRoleQuery(userEmail: string) {
  return queryOptions({
    queryKey: [UserKeys.gPanelRole, userEmail],
    queryFn: () => getUserGPanelRole(userEmail),
    meta: {
      errorMessage: Messages.Errors.Network.Loading(`this user's gPanel role`),
    },
  });
}

export async function getUserRoleAssignments(userEmail: string) {
  const res = await instance.get<RoleMember[]>(
    `/api/users/${userEmail}/roleAssignments`
  );
  return res.data;
}

export function getUserRoleAssignmentsQuery(userEmail: string) {
  return queryOptions({
    queryKey: [UserKeys.UserRoleAssignments, userEmail],
    queryFn: () => getUserRoleAssignments(userEmail),
    meta: {
      errorMessage: Messages.Errors.Network.Loading(`this user's roles`),
    },
  });
}

export async function updateUser(
  currentUser: User,
  updatedUser: Partial<User>,
  originalRoleName: string,
  roleName: string,
  changeLogMessage: string
) {
  const body: {
    currentUser: User;
    updatedUser: Partial<User>;
    originalRoleName: string;
    roleName: string;
  } = {
    currentUser,
    updatedUser,
    originalRoleName,
    roleName,
  };
  const res = await instance.put<User>(`/api/users/updateUserSettings`, body, {
    params: {
      changeLogMessage,
    },
  });
  return res.data;
}

export async function updateUserProfileInfo(
  userEmail: string,
  user: Partial<User>,
  changeLogMessage: string
) {
  const res = await instance.put<User>(
    `/api/users/updateUserProfileInfo/${userEmail}`,
    user,
    {
      params: {
        changeLogMessage,
      },
    }
  );
  return res.data;
}

export async function updateUserProfileInfoUserPortal(
  userEmail: string,
  user: Partial<User>
) {
  const res = await instance.put<User>(
    '/api/userPortal/users/updateUserProfileInfo',
    user,
    {
      params: {
        userEmail,
      },
    }
  );
  return res.data;
}

export async function deleteUser(
  userEmail: string,
  newUserEmail: string,
  changeLogMessage: string
) {
  const res = await instance.delete<void>(`/api/users`, {
    params: {
      userEmail,
      newUserEmail,
      changeLogMessage,
    },
  });
  return res.data;
}

export async function createUser(
  user: Partial<User>,
  roleName: string,
  groups: AddUserGroup[],
  sendEmail: boolean,
  emailQueueModel: EmailQueueModel,
  policies: Policy[],
  changeLogMessage: string,
  slackChannels: string[]
) {
  const body: {
    user: Partial<User>;
    groups: AddUserGroup[];
    gPanelRoleName: string;
    emailQueueModel: EmailQueueModel;
    selectedPolicies: Policy[];
    slackChannels: string[];
  } = {
    user,
    groups,
    gPanelRoleName: roleName,
    emailQueueModel: emailQueueModel,
    selectedPolicies: policies,
    slackChannels,
  };

  if (sendEmail) {
    body.emailQueueModel = emailQueueModel;
  }

  const res = await instance.post<User>(`/api/users`, body, {
    params: {
      changeLogMessage,
    },
  });
  return res.data;
}

export async function getAllOrgUnitsFromGoogle() {
  const res = await instance.get<OrgUnitModel[]>(
    `/api/organizations/getAllOrgUnitsFromGoogle`
  );
  return res.data;
}

// This endpoint is specifically used for all autocompletes and source pickers
export function getAllOrgUnitsFromGoogleQuery() {
  return queryOptions({
    queryKey: [UserKeys.OrgUnitsFromGoogle],
    queryFn: () => getAllOrgUnitsFromGoogle(),
    meta: {
      errorMessage: Messages.Errors.Network.Loading('org units'),
    },
  });
}

// This endpoint is specifically used to generate the tree in org units page so it does not have limited visibility and contains a permission check and app logging
export async function getAllOrgUnits() {
  const res = await instance.get<OrgUnitModel[]>(`/api/organizations`);
  return res.data;
}

export async function createOrgUnit(
  orgUnit: Partial<OrgUnitModel>,
  changeLogMessage: string
) {
  const res = await instance.post<OrgUnitModel>(
    `/api/organizations/addOrgUnit`,
    orgUnit,
    {
      params: {
        changeLogMessage,
      },
    }
  );
  return res.data;
}

export async function editOrgUnit(
  orgUnit: Partial<OrgUnitModel>,
  changeLogMessage: string,
  isRenameOrMoveWithChildren: boolean
) {
  const res = await instance.put<OrgUnitModel>(
    `/api/organizations/patchOrgUnit`,
    orgUnit,
    {
      params: {
        changeLogMessage,
        isRenameOrMoveWithChildren,
      },
    }
  );
  return res.data;
}

export async function deleteOrgUnit(
  orgUnit: OrgUnitModel,
  changeLogMessage: string
) {
  const res = await instance.delete<void>(`/api/organizations/deleteOrgUnit`, {
    data: orgUnit,
    params: {
      changeLogMessage,
    },
  });
  return res.data;
}

export async function getGroups(data: Page<Group[]>, searchTerm: string) {
  const res = await instance.post<Page<Group[]>>(`/api/search/groups`, data, {
    params: {
      pageSize: data.pageSize,
      text: searchTerm,
    },
  });
  return res.data;
}

export async function getGroupsUserPortal(
  data: Page<Group[]>,
  searchTerm: string
) {
  const res = await instance.post<Page<Group[]>>(
    `/api/userPortal/groups/getGroupsUserPortal`,
    data,
    {
      params: {
        pageSize: data.pageSize,
        text: searchTerm,
      },
    }
  );
  return res.data;
}

export async function getGroupTemplateById(id: number) {
  const res = await instance.get<GroupTemplate>(`/api/groupTemplates/${id}`);

  return res.data;
}

export async function getTotalGroupsCount(searchTerm: string) {
  const res = await instance.get<number>(`/api/search/groups/count`, {
    params: {
      text: searchTerm,
    },
  });
  return res.data;
}

export async function getDomains() {
  const res = await instance.get<string[]>(`/api/search/domains`);
  return res.data;
}
export async function getUserPortalDomains() {
  const res = await instance.get<string[]>(`/api/userPortal/search/domains`);
  return res.data;
}
export function getDomainsQuery(userView?: boolean) {
  return queryOptions({
    queryKey: [UserKeys.Domains, userView],
    queryFn: () => (userView ? getUserPortalDomains() : getDomains()),
    meta: {
      errorMessage: Messages.Errors.Network.Loading('domains'),
    },
  });
}

export async function getVerificationCodes(userEmail: string) {
  const res = await instance.get<string[]>(
    `/api/users/${userEmail}/verificationCodes`
  );
  return res.data;
}

export async function forceSignout(userEmail: string) {
  const res = await instance.get<void>(
    `/api/users/${userEmail}/resetSignInCookies`
  );
  return res.data;
}

export async function getUserRole() {
  const res = await instance.get<UserRole>(`/api/greeting/userRole`);
  return res.data;
}

export async function disableTwoFactor(userEmail: string) {
  const res = await instance.get<void>(
    `/api/users/${userEmail}/disableTwoFactorAuth`
  );
  return res.data;
}

export async function getUserAliases(userEmail: string) {
  const res = await instance.get<string[]>(`/api/users/${userEmail}/aliases`);
  return res.data;
}

export async function createUserAlias(
  userEmail: string,
  alias: string,
  changeLogMessage: string
) {
  const res = await instance.post<void>(
    `/api/users/${userEmail}/aliases/${alias}`,
    null,
    {
      params: {
        changeLogMessage,
      },
    }
  );
  return res.data;
}

export async function deleteUserAlias(
  userEmail: string,
  totalAliases: number,
  sourceType: string,
  aliasEmails: string[],
  changeLogMessage: string
) {
  const res = await instance.delete<boolean>(
    `/api/users/${userEmail}/aliases`,
    {
      params: {
        totalAliases,
        sourceType,
        aliasEmails,
        changeLogMessage,
      },
      paramsSerializer: (params) => {
        return qs.stringify(params, { arrayFormat: 'repeat' });
      },
    }
  );
  return res.data;
}

export async function transferAlias(
  userEmail: string,
  targetEmail: string,
  aliasEmails: string[],
  changeLogMessage: string
) {
  const res = await instance.put<void>(
    `/api/users/${userEmail}/aliases/transfer`,
    null,
    {
      params: {
        aliasEmails,
        targetEmail,
        changeLogMessage,
      },
      paramsSerializer: (params) => {
        return qs.stringify(params, { arrayFormat: 'repeat' });
      },
    }
  );
  return res.data;
}

export async function transferGroupAlias(
  userEmail: string,
  targetEmail: string,
  aliasEmails: string[],
  changeLogMessage: string
) {
  const res = await instance.put<void>(
    `/api/users/${userEmail}/aliases/transferGroup`,
    null,
    {
      params: {
        aliasEmails,
        targetEmail,
        changeLogMessage,
      },
      paramsSerializer: (params) => {
        return qs.stringify(params, { arrayFormat: 'repeat' });
      },
    }
  );
  return res.data;
}

export async function getContactGroups(userEmail: string) {
  const res = await instance.get<ContactGroup[]>(
    `/api/contacts/contactGroups/${userEmail}`
  );
  return res.data;
}

export async function getContactGroupsUserPortal() {
  const res = await instance.get<ContactGroup[]>(
    `/api/userPortal/contacts/contactGroups`
  );
  return res.data;
}

export async function updateContactGroup(
  userEmail: string,
  contactGroup: ContactGroup,
  changeLogMessage: string
) {
  delete contactGroup.systemGroup;
  const res = await instance.put<ContactGroup>(
    `/api/contacts/${userEmail}/contactGroups`,
    contactGroup,
    {
      params: {
        changeLogMessage,
      },
    }
  );
  return res.data;
}

export async function updateContactGroupUserPortal(contactGroup: ContactGroup) {
  delete contactGroup.systemGroup;
  const res = await instance.put<ContactGroup>(
    '/api/userPortal/contacts/updateContactGroup',
    contactGroup
  );
  return res.data;
}

export async function deleteContactGroup(
  userEmail: string,
  contactGroupId: string,
  changeLogMessage: string,
  deleteAllContacts: boolean
) {
  const res = await instance.delete<void>(`/api/contacts/deleteContactGroup`, {
    params: {
      userEmail,
      contactGroupId,
      changeLogMessage,
      deleteAllContacts,
    },
  });
  return res.data;
}

export async function deleteContactGroupUserPortal(
  contactGroupId: string,
  deleteAllContacts: boolean
) {
  const res = await instance.delete<void>(
    '/api/userPortal/contacts/deleteContactGroup',
    {
      params: {
        contactGroupId,
        deleteAllContacts,
      },
    }
  );
  return res.data;
}

export async function addContactGroup(
  formattedName: string,
  userEmailParam: string,
  changeLogMessage: string
) {
  const res = await instance.post<ContactGroup>(
    `/api/contacts/contactGroups/${userEmailParam}`,
    {
      formattedName,
    },
    {
      params: {
        changeLogMessage,
      },
    }
  );
  return res.data;
}

export async function addContactGroupUserPortal(formattedName: string) {
  const res = await instance.post<ContactGroup>(
    '/api/userPortal/contacts/addContactGroup',
    {
      formattedName,
    }
  );
  return res.data;
}

export async function getContactGroupContacts(
  userEmail: string,
  contactGroupId: string
) {
  const res = await instance.get<string[]>(
    `/api/contacts/contactGroupContacts/${userEmail}`,
    {
      params: {
        contactGroupId,
      },
    }
  );
  return res.data;
}

export async function getContactGroupContactsUserPortal(
  contactGroupId: string
) {
  const res = await instance.get<string[]>(
    '/api/userPortal/contacts/contactGroupContacts',
    {
      params: {
        contactGroupId,
      },
    }
  );
  return res.data;
}

export async function getContacts(userEmail: string, groupMembers: string[]) {
  const res = await instance.post<Person[]>(
    `/api/contacts/${userEmail}`,
    groupMembers
  );
  return res.data;
}

export async function searchContacts(userEmail: string, searchString: string) {
  const res = await instance.get<Person[]>(`/api/contacts/searchContacts`, {
    params: {
      userEmail,
      searchString,
    },
  });
  return res.data;
}

export async function searchUserPortalContacts(
  userEmail: string,
  searchString: string
) {
  const res = await instance.get<Person[]>(
    `/api/userPortal/contacts/searchContacts`,
    {
      params: {
        userEmail,
        searchString,
      },
    }
  );
  return res.data;
}

export async function getContactsUserPortal(groupMembers: string[]) {
  const res = await instance.post<Person[]>(
    '/api/userPortal/contacts/getContacts',
    groupMembers
  );
  return res.data;
}

export async function addContact(
  userEmail: string,
  person: {
    emailAddresses: [{ value: string }];
    memberships: [
      { contactGroupMembership: { contactGroupResourceName: string } },
    ];
    names: [{ familyName: string; givenName: string }];
  },
  changeLogMessage: string
) {
  const res = await instance.post<Person>(
    `/api/contacts/addContact/${userEmail}`,
    person,
    {
      params: {
        changeLogMessage,
      },
    }
  );
  return res.data;
}

export async function addContactUserPortal(person: {
  emailAddresses: [{ value: string }];
  memberships: [
    { contactGroupMembership: { contactGroupResourceName: string } },
  ];
  names: [{ familyName: string; givenName: string }];
}) {
  const res = await instance.post<Person>(
    '/api/userPortal/contacts/addContact',
    person
  );
  return res.data;
}

export async function deleteContacts(
  userEmail: string,
  resourceNames: string[],
  changeLogMessage: string
) {
  const res = await instance.delete<void>(
    `/api/contacts/deleteContacts/${userEmail}`,
    {
      data: resourceNames,
      params: {
        changeLogMessage,
      },
    }
  );
  return res.data;
}

export async function deleteContactsUserPortal(resourceNames: string[]) {
  const res = await instance.delete<void>(
    '/api/userPortal/contacts/deleteContacts',
    {
      data: resourceNames,
    }
  );
  return res.data;
}

export async function moveContacts(
  userEmail: string,
  models: FormPerson[],
  moveToGroupIds: string[],
  changeLogMessage: string
) {
  const res = await instance.put<void>(`/api/contacts/moveContacts`, models, {
    params: {
      moveToGroupIds,
      userEmail,
      changeLogMessage,
    },
    paramsSerializer: (params) => {
      return qs.stringify(params, { arrayFormat: 'repeat' });
    },
  });
  return res.data;
}

export async function moveContactsUserPortal(
  models: FormPerson[],
  moveToGroupIds: string[]
) {
  const res = await instance.put<void>(
    '/api/userPortal/contacts/moveContacts',
    models,
    {
      params: {
        moveToGroupIds,
      },
      paramsSerializer: (params) => {
        return qs.stringify(params, { arrayFormat: 'repeat' });
      },
    }
  );
  return res.data;
}

export async function exportContacts(
  userEmail: string,
  sourceType: string,
  changeLogMessage: string
) {
  const res = await instance.get<string>(
    `/api/contacts/exportContacts/${userEmail}`,
    {
      params: {
        sourceType,
        changeLogMessage,
      },
    }
  );
  return res.data;
}

export async function exportContactsUserPortal(sourceType: string) {
  const res = await instance.get<string>(
    '/api/userPortal/contacts/exportContacts',
    {
      params: {
        sourceType,
      },
    }
  );
  return res.data;
}

export async function getAllPolicies() {
  const res = await instance.get<Policy[]>(`/api/policies/getAllPolicies`);
  return res.data;
}

export function getAllPoliciesQuery() {
  return queryOptions({
    queryKey: [UserKeys.Policies],
    queryFn: () => getAllPolicies(),
    meta: {
      errorMessage: Messages.Errors.Network.Loading('policies'),
    },
  });
}

export async function getPolicies(data: Page<Policy[]>) {
  const res = await instance.post<Page<Policy[]>>(`/api/policies`, data, {
    params: {
      pageSize: data.pageSize,
    },
  });
  return res.data;
}

export async function getPolicyCount() {
  const res = await instance.get<number>(`/api/policies/getPolicyCount`);
  return res.data;
}

export async function getPoliciesByType(type: string) {
  const res = await instance.get<Policy[]>(`/api/policies/${type}`);
  return res.data;
}
export async function getPolicyActions(policy: Policy) {
  const res = await instance.post<Policy>(`/api/policies/actions`, policy);
  return res.data;
}

export async function getUserGroups(userEmail: string, data: Page<Group[]>) {
  const res = await instance.post<Page<Group[]>>(
    `/api/users/groups/${userEmail}`,
    data
  );
  return res.data;
}

export async function getUserGroupsUserPortal(
  userEmail: string,
  data: Page<Group[]>
) {
  const res = await instance.post<Page<Group[]>>(
    '/api/userPortal/users/groups',
    data,
    {
      params: {
        userEmail,
      },
    }
  );
  return res.data;
}

export async function deleteUserFromGroups(
  userEmail: string,
  targets: string[],
  source: string,
  changeLogMessage: string
) {
  const res = await instance.delete<void>(
    `/api/users/groups/delete/${userEmail}/${source}`,
    {
      params: {
        targets,
        changeLogMessage,
      },
      paramsSerializer: (params) => {
        return qs.stringify(params, { arrayFormat: 'repeat' });
      },
    }
  );
  return res.data;
}

export async function addUserToGroups(
  userEmail: string,
  groups: AddUserGroup[],
  changeLogMessage: string
) {
  const res = await instance.post<void>(
    `/api/users/groups/${userEmail}/bulkAdd`,
    groups,
    {
      params: {
        changeLogMessage,
      },
    }
  );
  return res.data;
}

export async function addMemberToGroup(
  userEmail: string,
  groups: string[],
  role: string,
  changeLogMessage: string
) {
  const res = await instance.post<void>(
    `/api/users/groups/${userEmail}/compareGroups/${role}`,
    groups,
    {
      params: {
        changeLogMessage,
      },
    }
  );
  return res.data;
}

export async function addMemberToDelta(
  userEmail: string,
  copyGroups: string[],
  role: string,
  comparedUser: string,
  deltaGroups: string[],
  changeLogMessage: string
) {
  const request1 = instance.post<void>(
    `/api/users/groups/${userEmail}/compareGroups/${role}`,
    copyGroups,
    {
      params: {
        changeLogMessage,
      },
    }
  );
  const request2 = instance.post<void>(
    `/api/users/groups/${comparedUser}/compareGroups/${role}`,
    deltaGroups,
    {
      params: {
        changeLogMessage,
      },
    }
  );
  const responses = await Promise.all([request1, request2]);
  return responses[1].data;
}

export async function getEmailMonitors(userEmail: string) {
  const res = await instance.get<EmailMonitor[]>(
    `/api/users/emailMonitors/${userEmail}`
  );
  return res.data;
}

export async function deleteEmailMonitor(
  userEmail: string,
  model: EmailMonitor,
  changeLogMessage: string
) {
  const res = await instance.delete<void>(
    `/api/users/emailMonitors/${userEmail}`,
    {
      data: model,
      params: {
        changeLogMessage,
      },
    }
  );
  return res.data;
}

export async function deleteEmailMonitors(
  userEmail: string,
  listeningUsers: string[],
  changeLogMessage: string
) {
  const res = await instance.delete<void>(`/api/users/deleteEmailMonitors`, {
    data: listeningUsers,
    params: {
      userEmail,
      changeLogMessage,
    },
  });
  return res.data;
}

export async function getAllUserMobileDevices(userEmail: string) {
  const res = await instance.get<MobileDevice[]>(`/api/devices/${userEmail}`);
  return res.data;
}

export async function searchMobileDevices(mobileSearch: MobileSearchFilter) {
  const res = await instance.post<MobileDevice[]>(
    `/api/devices/mobileManagementSearch`,
    mobileSearch
  );
  return res.data;
}

export async function getAllDevices() {
  const res = await instance.get<ChromeDeviceModel[]>(
    `/api/chromeDevices/getAllDevices`
  );

  return res.data;
}

export async function getPageOfChromeDevices(
  page: Page<ChromeDeviceModel[]>,
  filter: string,
  sortColumn: string,
  sortDirection: string
) {
  const res = await instance.post<Page<ChromeDeviceModel[]>>(
    `/api/chromeDevices/getPageOfChromeDevices`,
    page,
    {
      params: { filter, sortColumn, sortDirection },
    }
  );
  return res.data;
}

export async function getIndexedMobileDevices(
  page: BigQueryPage<MobileDevice[]>,
  filters: GridFilterModel,
  sortItems: GridSortModel
) {
  const body: {
    page: BigQueryPage<MobileDevice[]>;
    filters: GridFilterModel;
    sortItems: GridSortModel;
  } = {
    page,
    filters,
    sortItems,
  };
  const res = await instance.post<BigQueryPage<MobileDevice[]>>(
    `/api/devices/getIndexedPageOfMobileDevicesForDomain`,
    body
  );
  return res.data;
}

export async function getIndexedPageGroups(
  page: BigQueryPage<Group[]>,
  filters: GridFilterModel,
  sortItems: GridSortModel
) {
  const body: {
    page: BigQueryPage<Group[]>;
    filters: GridFilterModel;
    sortItems: GridSortModel;
  } = {
    page,
    filters,
    sortItems,
  };
  const res = await instance.post<BigQueryPage<Group[]>>(
    `/api/groups/getIndexedPageGroupsForDomain`,
    body
  );
  return res.data;
}

export async function getGroupHealthSummary() {
  const res = await instance.get<GroupHealthSummary>(
    `/api/groups/getGroupHealthSummary`
  );
  return res.data;
}

export async function getGroupHealthSettings() {
  const res = await instance.get<GroupHealthSettings>(
    `/api/groups/getGroupHealthSettings`
  );
  return res.data;
}

export async function updateGroupHealthSettings(
  settings: GroupHealthSettings,
  changeLogMessage: string
) {
  const res = await instance.post<GroupHealthSettings>(
    `/api/groups/updateGroupHealthSettings`,
    settings,
    {
      params: {
        changeLogMessage,
      },
    }
  );
  return res.data;
}

export async function addEmailMonitor(
  userEmail: string,
  model: Partial<EmailMonitor>,
  changeLogMessage: string
) {
  const res = await instance.post<void>(
    `/api/users/emailMonitors/${userEmail}`,
    model,
    {
      params: {
        changeLogMessage,
      },
    }
  );
  return res.data;
}

export async function editEmailMonitor(
  userEmail: string,
  model: Partial<EmailMonitor>,
  changeLogMessage: string
) {
  const res = await instance.post<void>(
    `/api/users/editEmailMonitor/${userEmail}`,
    model,
    {
      params: {
        changeLogMessage,
      },
    }
  );
  return res.data;
}

export async function approveDevice(
  resource: MobileDevice,
  changeLogMessage: string
) {
  const res = await instance.put<void>(`/api/devices/approve`, resource, {
    params: {
      changeLogMessage,
    },
  });
  return res.data;
}

export async function blockDevice(
  resource: MobileDevice,
  changeLogMessage: string
) {
  const res = await instance.put<void>(`/api/devices/block`, resource, {
    params: {
      changeLogMessage,
    },
  });
  return res.data;
}

export async function wipeDevice(
  resource: MobileDevice,
  changeLogMessage: string
) {
  const res = await instance.put<void>(`/api/devices/wipe`, resource, {
    params: {
      changeLogMessage,
    },
  });
  return res.data;
}

export async function wipeAccountDevice(
  resource: MobileDevice,
  changeLogMessage: string
) {
  const res = await instance.put<void>(`/api/devices/wipeAccount`, resource, {
    params: {
      changeLogMessage,
    },
  });
  return res.data;
}

export async function deleteDevice(
  resource: MobileDevice,
  changeLogMessage: string
) {
  const res = await instance.delete<void>(`/api/devices/delete`, {
    data: resource,
    params: {
      changeLogMessage,
    },
  });
  return res.data;
}

export async function takeActionOnDevices(
  deviceAction: MobileDeviceAction,
  deviceList: MobileDevice[],
  changeLogMessage: string
) {
  const res = await instance.post<void>(
    `/api/devices/takeActionOnDevices`,
    deviceList,
    {
      params: {
        deviceAction,
        changeLogMessage,
      },
    }
  );
  return res.data;
}

export async function exportMobileDevices(
  changeLogMessage: string = 'Exported mobile devices'
) {
  const res = await instance.post<string>(`/api/devices/exportMobileDevices`, {
    params: { changeLogMessage },
  });

  return res.data;
}

export async function getCalendars(
  userEmail: string,
  changeLogMessage?: string
) {
  const res = await instance.get<Calendar[]>(`/api/calendars/${userEmail}`, {
    params: { changeLogMessage },
  });
  return res.data.sort((a, b) => a.summary.localeCompare(b.summary));
}

export async function getCalendarsForTab(
  userEmail: string,
  changeLogMessage?: string
) {
  const res = await instance.get<Calendar[]>(
    `/api/calendars/tab/${userEmail}`,
    {
      params: { changeLogMessage },
    }
  );
  return res.data.sort((a, b) => a.summary.localeCompare(b.summary));
}

export async function getCalendarEvents(
  calendar: Partial<Calendar>,
  startTime: number,
  endTime: number,
  changeLogMessage?: string
) {
  const res = await instance.post<CalendarEventModel[]>(
    `/api/calendars/events`,
    calendar,
    {
      params: {
        startTime,
        endTime,
        changeLogMessage,
      },
    }
  );
  return res.data;
}

export async function getCalendarEvent(calendarId: string, eventId: string) {
  const res = await instance.get<CalendarEventModel>(
    `/api/calendars/events/${calendarId}/${eventId}`
  );
  return res.data;
}

export async function createCalendarEvent(
  calendarId: string,
  sendNotifications: boolean,
  eventModel: Partial<CalendarEventModel>,
  changeLogMessage: string
) {
  const res = await instance.post<CalendarEventModel>(
    `/api/calendars/events/createEvent`,
    eventModel,
    {
      params: {
        calendarId,
        sendNotifications,
        changeLogMessage,
      },
    }
  );

  return res.data;
}

export async function updateCalendarEvent(
  userEmail: string,
  calendarId: string,
  eventId: string,
  sendNotifications: boolean,
  eventModel: Partial<CalendarEventModel>,
  // null if not moving
  movingToCalId: string | null,
  changeLogMessage: string
) {
  const res = await instance.put<CalendarEventModel>(
    `/api/calendars/events/updateEvent`,
    eventModel,
    {
      params: {
        userEmail,
        calendarId,
        eventId,
        sendNotifications,
        movingToCalId,
        changeLogMessage,
      },
    }
  );

  return res.data;
}

export async function moveCalendarEvent(
  userEmail: string,
  calendarId: string,
  eventId: string,
  destinationEmail: string,
  changeLogMessage: string
) {
  const res = await instance.put<void>(
    `/api/calendars/events/changeEventOrganizer`,
    null,
    {
      params: {
        userEmail,
        calendarId,
        eventId,
        destinationId: destinationEmail,
        changeLogMessage,
      },
    }
  );

  return res.data;
}

export async function deleteCalendarEvent(
  userEmail: string,
  calendarId: string,
  eventModel: Partial<CalendarEventModel>,
  changeLogMessage: string
) {
  const res = await instance.delete<CalendarEventModel>(
    `/api/calendars/events/deleteEvent`,
    {
      data: eventModel,
      params: {
        userEmail,
        calendarId,
        changeLogMessage,
      },
    }
  );

  return res.data;
}

export async function createCalendar(
  userEmail: string,
  calendar: Partial<Calendar>,
  changeLogMessage: string
) {
  const res = await instance.post<Calendar>(
    `/api/calendars/${userEmail}/createCalendar`,
    calendar,
    {
      params: {
        changeLogMessage,
      },
    }
  );
  return res.data;
}

export async function deleteCalendar(
  userEmail: string,
  calendar: Calendar,
  changeLogMessage: string
) {
  const res = await instance.delete<void>(`/api/calendars/${userEmail}`, {
    data: calendar,
    params: {
      changeLogMessage,
    },
  });
  return res.data;
}

export async function bulkDeleteCalendars(
  userEmail: string,
  selectedCalendars: Calendar[],
  changeLogMessage: string
) {
  const res = await instance.delete<void>(
    `/api/calendars/bulkDeleteCalendars/${userEmail}`,
    {
      data: selectedCalendars,
      params: {
        changeLogMessage,
      },
    }
  );
  return res.data;
}

export async function transferCalendars(
  transferModel: TransferOwnershipModel,
  changeLogMessage: string
) {
  const res = await instance.post<string>(
    `/api/calendars/startDataTransfer`,
    transferModel,
    {
      params: {
        changeLogMessage,
      },
    }
  );
  return res.data;
}

export async function updateCalendar(
  userEmail: string,
  calendar: Partial<Calendar>,
  changeLogMessage: string
) {
  const res = await instance.put<void>(
    `/api/calendars/${userEmail}`,
    calendar,
    {
      params: {
        calId: calendar.id,
        changeLogMessage,
      },
    }
  );
  return res.data;
}

export async function getCalendarAcls(userEmail: string, calendar: Calendar) {
  const res = await instance.post<CalendarAclResource[]>(
    `/api/calendars/${userEmail}/acls`,
    calendar
  );
  return res.data;
}

export async function updateCalendarAcls(
  userEmail: string,
  calendar: Calendar,
  changes: CalendarAclResource[]
) {
  const res = await instance.put<void>(`/api/calendars/${userEmail}/acls`, {
    calModel: calendar,
    changes,
  });
  return res.data;
}

export async function updateCalendarAcl(
  userEmail: string,
  calendar: Calendar,
  acl: CalendarAclResource
) {
  const res = await instance.put<void>(`/api/calendars/${userEmail}/acl`, {
    calModel: calendar,
    acl,
  });
  return res.data;
}

export async function deleteCalendarAcl(
  userEmail: string,
  calendar: Calendar,
  aclId: string
) {
  const res = await instance.delete<void>(`/api/calendars/${userEmail}/acl`, {
    data: calendar,
    params: {
      aclId,
    },
  });
  return res.data;
}

export async function getThirdPartyApps(userEmail: string) {
  const res = await instance.get<ThirdPartyApp[]>(
    `/api/security/tokens/${userEmail}`
  );
  return res.data;
}

export async function deleteThirdPartyApps(
  userEmail: string,
  tokens: ThirdPartyApp[],
  changeLogMessage: string
) {
  const res = await instance.delete<void>(`/api/security/tokens/${userEmail}`, {
    data: tokens,
    params: {
      changeLogMessage,
    },
  });
  return res.data;
}

export async function getAppPasswords(userEmail: string) {
  const res = await instance.get<AppPassword[]>(`/api/security/${userEmail}`);
  return res.data;
}

export async function deleteAppPassword(
  userEmail: string,
  asp: AppPassword,
  changeLogMessage: string
) {
  const res = await instance.delete<void>(`/api/security/${userEmail}`, {
    data: asp,
    params: {
      changeLogMessage,
    },
  });
  return res.data;
}

export async function runReport(
  sourceEmail: string,
  report: string,
  sourceType: string,
  reportModel: Partial<ReportModel>,
  changeLogMessage: string
) {
  const res = await instance.post<string>(`/api/reports`, reportModel, {
    params: {
      report,
      sourceEmail,
      sourceType,
      changeLogMessage,
    },
  });
  return res.data;
}

export async function getDriveTransferLogs(
  dataTransferLogPage: Page<DataTransferLog[]>,
  pageSize: number
) {
  const res = await instance.post<Page<DataTransferLog[]>>(
    `/api/drive/listDataTransferLogs`,
    dataTransferLogPage,
    {
      params: {
        pageSize,
      },
    }
  );
  return res.data;
}

export async function getDriveMonitors(
  monitorData: Page<DriveSweepModel[]>,
  pageSize: number
) {
  const res = await instance.post<Page<DriveSweepModel[]>>(
    `/api/drive/getDriveMonitors`,
    monitorData,
    {
      params: {
        pageSize,
      },
    }
  );
  return res.data;
}

export async function getAllDriveMonitors() {
  const res = await instance.get<DriveSweepModel[]>(
    `/api/drive/getAllDriveMonitors`
  );
  return res.data;
}

export async function getDriveMonitorLogs(
  logData: Page<DriveMonitorJobLog[]>,
  folderId: string
) {
  const res = await instance.post<Page<DriveMonitorJobLog[]>>(
    `/api/drive/getDriveMonitorLogs`,
    logData,
    {
      params: {
        folderId,
      },
    }
  );
  return res.data;
}

export async function createDriveMonitor(
  model: Partial<DriveSweepModel>,
  changeLogMessage: string
) {
  const res = await instance.post<void>(
    `/api/drive/createDriveMonitor`,
    model,
    {
      params: {
        changeLogMessage,
      },
    }
  );
  return res.data;
}

export async function startDriveMonitor(
  model: Partial<DriveSweepModel>,
  changeLogMessage: string
) {
  const res = await instance.post<void>(`/api/drive/startDriveMonitor`, model, {
    params: {
      changeLogMessage,
    },
  });
  return res.data;
}

export async function updateDriveMonitor(
  model: Partial<DriveSweepModel>,
  changeLogMessage: string
) {
  const res = await instance.put<void>(`/api/drive/updateDriveMonitor`, model, {
    params: {
      changeLogMessage,
    },
  });
  return res.data;
}

export async function deleteDriveMonitor(
  model: Partial<DriveSweepModel>,
  changeLogMessage: string
) {
  const res = await instance.delete<void>(`/api/drive/deleteDriveMonitor`, {
    data: model,
    params: {
      changeLogMessage,
    },
  });
  return res.data;
}

export async function deleteDriveMonitorsReact(
  folderIds: string[],
  changeLogMessage: string
) {
  const res = await instance.delete<void>(
    `/api/drive/deleteDriveMonitorsReact`,
    {
      data: folderIds,
      params: {
        changeLogMessage,
      },
    }
  );
  return res.data;
}

export async function bulkUpdateDriveMonitorStatus(
  folderIds: string[],
  isSetActive: boolean,
  changeLogMessage: string
) {
  const res = await instance.post<void>(
    `/api/drive/updateDriveMonitorStatus`,
    folderIds,
    {
      params: {
        isSetActive,
        changeLogMessage,
      },
    }
  );
  return res.data;
}

export async function getDriveRootId(userEmail: string) {
  const res = await instance.get<string>(`/api/drive/${userEmail}`);
  return res.data;
}

export async function getDriveRootIdForDriveTab(
  userEmail: string,
  changeLogMessage?: string
) {
  const res = await instance.get<string>(`/api/drive/tab/${userEmail}`, {
    params: {
      changeLogMessage,
    },
  });
  return res.data;
}

export async function getDriveRootIdForExplorer(
  userEmail: string,
  changeLogMessage?: string
) {
  const res = await instance.get<string>(`/api/drive/explorer/${userEmail}`, {
    params: {
      changeLogMessage,
    },
  });
  return res.data;
}

export async function getDocById(userEmail: string, docId: string) {
  const res = await instance.get<Doc>(`/api/drive/getDocById`, {
    params: {
      userEmail,
      docId,
    },
  });
  return res.data;
}

export async function getCurrentFolderName(userEmail: string, docId: string) {
  const res = await instance.get<string>(`/api/drive/getCurrentFolderName`, {
    params: {
      userEmail,
      docId,
    },
  });
  return res.data;
}

export async function getDriveFolders(
  userEmail: string,
  id: string,
  onlyOwned: boolean,
  includeTrash: boolean,
  onlyShared: boolean,
  onlyStarred: boolean,
  referer: string
) {
  if (!id || id === '' || !userEmail || userEmail === '') return [];

  const res = await instance.get<Folder[]>(
    `/api/drive/folders/${userEmail}/${id}`,
    {
      params: {
        onlyOwned,
        includeTrash,
        onlyShared,
        onlyStarred,
        referer,
      },
    }
  );
  return res.data;
}

export async function getDriveFoldersForTab(
  userEmail: string,
  id: string,
  onlyOwned: boolean,
  includeTrash: boolean,
  onlyShared: boolean,
  onlyStarred: boolean,
  referer: string
) {
  if (!id || id === '' || !userEmail || userEmail === '') return [];

  const res = await instance.get<Folder[]>(
    `/api/drive/tab/folders/${userEmail}/${id}`,
    {
      params: {
        onlyOwned,
        includeTrash,
        onlyShared,
        onlyStarred,
        referer,
      },
    }
  );
  return res.data;
}

export async function getDriveFoldersOwnedByMe(
  page: {
    cursor: string | null;
    pageSize: number;
  },
  userEmail: string,
  driveColumns: string,
  sortDirection: string
) {
  const res = await instance.post<Page<Folder[]>>(
    `/api/drive/foldersOwnedByMe/${userEmail}`,
    page,
    {
      params: {
        driveColumns,
        sortDirection,
      },
    }
  );
  return res.data;
}

export async function getPageOfDriveFolders(
  userEmail: string,
  data: Page<Folder[]>,
  id: string,
  onlyOwned: boolean,
  includeTrash: boolean,
  onlyShared: boolean,
  onlyStarred: boolean,
  referer: string,
  driveColumns: string,
  sortDirection: string
) {
  const res = await instance.post<Page<Folder[]>>(
    `/api/drive/foldersByPage/${userEmail}/${id}`,
    data,
    {
      params: {
        onlyOwned,
        includeTrash,
        onlyShared,
        onlyStarred,
        referer,
        driveColumns,
        sortDirection,
      },
    }
  );
  return res.data;
}

export async function getPageOfDocs(
  userEmail: string,
  data: Page<Doc[]>,
  folderId: string,
  onlyOwned: boolean,
  includeTrashed: boolean,
  onlyShared: boolean,
  onlyStarred: boolean,
  driveColumns: string,
  sortDirection: string
) {
  const res = await instance.post<Page<Doc[]>>(
    `/api/drive/docs/${userEmail}/${folderId}`,
    data,
    {
      params: {
        onlyOwned,
        includeTrashed,
        onlyShared,
        onlyStarred,
        driveColumns,
        sortDirection,
      },
    }
  );
  return res.data;
}

export async function getDriveHierarchy(id: string, docOwner: string) {
  const res = await instance.get<DocLocation[]>(
    `/api/drive/folders/parents/${id}`,
    {
      params: {
        docOwner,
      },
    }
  );
  return res.data;
}

export async function updateStarredDocStatus(
  userEmail: string,
  docId: string,
  starred: boolean,
  changeLogMessage: string
) {
  const res = await instance.put<void>(
    `/api/drive/docs/${userEmail}/${docId}`,
    null,
    {
      params: {
        starred,
        changeLogMessage,
      },
    }
  );

  return res.data;
}

export async function updateDocName(
  userEmail: string,
  docId: string,
  newTitle: string,
  changeLogMessage: string
) {
  const res = await instance.put<void>(
    `/api/drive/docs/name/${userEmail}/${docId}`,
    null,
    {
      params: {
        newTitle,
        changeLogMessage,
      },
    }
  );

  return res.data;
}

export async function updateTrashedDocsStatus(
  userEmail: string,
  docs: Doc[],
  trashed: boolean,
  changeLogMessage: string
) {
  const res = await instance.post<void>(`/api/drive/docs/${userEmail}`, docs, {
    params: {
      trashed,
      changeLogMessage,
    },
  });
  return res.data;
}

export async function createDriveFolder(
  userEmail: string,
  folderName: string,
  parentId: string,
  changeLogMessage: string
) {
  const res = await instance.post<string>(
    `/api/drive/folders/${userEmail}`,
    null,
    {
      params: {
        parentId,
        folderName,
        changeLogMessage,
      },
    }
  );
  return res.data;
}

export async function deleteDriveDocs(
  userEmail: string,
  docs: Doc[],
  changeLogMessage: string
) {
  const res = await instance.delete<void>(`/api/drive/docs/${userEmail}`, {
    data: docs,
    params: {
      changeLogMessage,
    },
  });
  return res.data;
}

export async function removeDriveDocumentLabels(
  userEmail: string,
  docIds: string[],
  labelIdsByDocId: Record<string, string[]>,
  changeLogMessage: string
) {
  const res = await instance.post<{ executedDirectly: boolean }>(
    `/api/drive/docs/labels/remove/${encodeURIComponent(userEmail)}`,
    { docIds, labelIdsByDocId },
    {
      params: {
        changeLogMessage,
      },
    }
  );
  return res.data;
}

export async function removeAllDriveDocumentLabels(
  userEmail: string,
  docIds: string[],
  labelIdsByDocId: Record<string, string[]>,
  changeLogMessage: string
) {
  const res = await instance.post<{ executedDirectly: boolean }>(
    `/api/drive/docs/labels/removeAll/${encodeURIComponent(userEmail)}`,
    { docIds, labelIdsByDocId },
    {
      params: {
        changeLogMessage,
      },
    }
  );
  return res.data;
}

export async function moveDocuments(
  userEmail: string,
  docs: Doc[],
  newParentId: string,
  changeLogMessage: string,
  isSharedDriveFolder: boolean,
  driveOrFolderId: string
) {
  if (isSharedDriveFolder) {
    return moveSharedDriveFiles(docs, driveOrFolderId, changeLogMessage);
  } else {
    moveDocumentsToNewFolder(userEmail, docs, newParentId, changeLogMessage);
    return {
      success: true,
      message: 'The task to move the documents or folders has started.',
    };
  }
}

export async function addShortcutToDrive(
  userEmail: string,
  docId: string,
  newParentId: string,
  changeLogReason: string
) {
  const res = await instance.post<void>(
    `/api/drive/docs/addShortcut/${docId}`,
    null,
    {
      params: {
        userEmail,
        newParentId,
        changeLogReason,
      },
    }
  );
  return res.data;
}

export async function moveDocumentsToNewFolder(
  userEmail: string,
  docs: Doc[],
  newParentId: string,
  changeLogMessage: string
) {
  const res = await instance.post<void>(`/api/drive/docs/move`, docs, {
    params: {
      newParentId,
      userEmail,
      changeLogMessage,
    },
  });
  return res.data;
}

export async function copyDocument(
  userEmail: string,
  docId: string,
  newTitle: string,
  newParent: string,
  changeLogMessage: string
) {
  const res = await instance.post<Doc>(`/api/drive/docs/copy`, null, {
    params: {
      userEmail,
      docId,
      newTitle,
      newParent,
      changeLogMessage,
    },
  });
  return res.data;
}

export async function transferDocuments(
  transferModel: TransferOwnershipModel,
  emailsToNotify: string[],
  changeLogMessage: string
) {
  if (transferModel.notifyByEmail) {
    transferModel.emailsToNotify = emailsToNotify;
  }

  const res = await instance.post<void>(
    `/api/drive/docs/transfer`,
    transferModel,
    {
      params: {
        changeLogMessage,
      },
    }
  );
  return res.data;
}

export async function addSharePermissionToDocs(
  userEmail: string,
  docs: Doc[],
  newUser: string,
  sharePermission: string,
  changeLogMessage: string,
  expirationTime?: number
) {
  const res = await instance.post<void>(`/api/drive/docs/add-share`, docs, {
    params: {
      userEmail,
      newUserShare: newUser,
      permString: sharePermission,
      changeLogMessage,
      expirationTime,
    },
  });
  return res.data;
}

export async function getDocumentAcls(
  docOwnerEmail: string,
  docId: string,
  mimeType: string
) {
  const res = await instance.get<GPanelPermissionsModel[]>(`/api/share/acl`, {
    params: {
      docOwnerEmail,
      docId,
      mimeType,
    },
  });
  return res.data;
}

export async function getDocumentPermissions(userEmail: string, docId: string) {
  const res = await instance.get<GPanelPermissionsModel | ''>(
    `/api/share/perms`,
    {
      params: {
        userEmail,
        docId,
      },
    }
  );
  return res.data;
}

export async function updateDocumentPermissions(
  fileId: string,
  docOwnerEmail: string,
  docTitle: string,
  changeLogMessage: string,
  newPerm: Partial<GPanelPermissionsModel>
) {
  const res = await instance.post<void>(
    `/api/share/updateGlobalPerm`,
    newPerm,
    {
      params: {
        fileId,
        docOwnerEmail,
        docTitle,
        changeLogMessage,
      },
    }
  );
  return res.data;
}

export async function deleteDocumentPermissions(
  fileId: string,
  docOwnerEmail: string,
  permId: string,
  docTitle: string,
  changeLogMessage: string
) {
  const res = await instance.delete<void>(`/api/share/removeGlobalPerm`, {
    params: {
      fileId,
      docOwnerEmail,
      permId,
      docTitle,
      changeLogMessage,
    },
  });
  return res.data;
}

export async function updateDocumentAcls(
  docId: string,
  docOwnerEmail: string,
  mimeType: string,
  changes: GPanelPermissionsModel[],
  docTitle: string,
  changeLogMessage: string
) {
  interface GPanelPermissionsModelMap {
    [userEmail: string]: GPanelPermissionsModel;
  }

  const combinedObject: GPanelPermissionsModelMap = {};

  changes.forEach((change) => {
    combinedObject[change.userEmail!] = change;
  });

  const res = await instance.post<string[]>(
    `/api/share/makeAclChanges`,
    combinedObject,
    {
      params: {
        docId,
        docOwnerEmail,
        mimeType,
        docTitle,
        changeLogMessage,
      },
    }
  );
  return res.data;
}

export async function betaGetGmailLabels(userEmail: string) {
  const res = await instance.get<LabelModel[]>(
    `/api/users/labels/${userEmail}`
  );
  return res.data;
}

export async function betaAddGmailLabel(
  userEmail: string,
  label: LabelModel,
  changeLogMessage: string
) {
  const res = await instance.post<LabelModel>(
    `/api/users/labels/${userEmail}`,
    label,
    {
      params: {
        changeLogMessage,
      },
    }
  );
  return res.data;
}

export async function betaDeleteGmailLabels(
  userEmail: string,
  labels: LabelModel[],
  changeLogMessage: string
) {
  const res = await instance.delete<void>(`/api/users/labels/${userEmail}`, {
    data: labels,
    params: {
      changeLogMessage,
    },
  });
  return res.data;
}

export async function betaUpdateGmailLabel(
  userEmail: string,
  label: LabelModel,
  changeLogMessage: string
) {
  const res = await instance.put<LabelModel>(
    `/api/users/labels/${userEmail}`,
    label,
    {
      params: {
        changeLogMessage,
      },
    }
  );
  return res.data;
}

export async function betaListGmailAccountDelegates(userEmail: string) {
  const res = await instance.get<DelegateModel[]>(
    `/api/users/delegates/${userEmail}`
  );
  return res.data;
}

export async function listExpiringGmailAccountDelegates(userEmail: string) {
  const res = await instance.get<ExpiringGmailDelegate[]>(
    `/api/users/expiringDelegates/${userEmail}`
  );
  return res.data;
}

export async function betaAddGmailAccountDelegate(
  userEmail: string,
  delegateEmail: string,
  changeLogMessage: string
) {
  const res = await instance.post<void>(
    `/api/users/delegates/${userEmail}`,
    delegateEmail,
    {
      params: {
        changeLogMessage,
      },
    }
  );
  return res.data;
}

export async function createExpiringGmailAccountDelegate(
  userEmail: string,
  delegateEmail: string,
  expirationTime: number,
  changeLogMessage: string
) {
  const res = await instance.post<void>(
    `/api/users/expiringDelegates/${userEmail}`,
    null,
    {
      params: {
        delegateEmail,
        expirationTime,
        changeLogMessage,
      },
    }
  );
  return res.data;
}

export async function deleteGmailAccountDelegate(
  userEmail: string,
  delegateEmail: string,
  changeLogMessage: string
) {
  const res = await instance.delete<void>(`/api/users/delegates/${userEmail}`, {
    data: delegateEmail,
    params: {
      changeLogMessage,
    },
  });
  return res.data;
}

export async function deleteExpiringGmailAccountDelegate(
  userEmail: string,
  delegateEmail: string,
  changeLogMessage: string
) {
  const res = await instance.delete<void>(
    `/api/users/expiringDelegates/${userEmail}`,
    {
      data: delegateEmail,
      params: {
        changeLogMessage,
      },
    }
  );
  return res.data;
}

export async function betaListForwardingAddresses(userEmail: string) {
  const res = await instance.get<ForwardingAddressModel[]>(
    `/api/users/forwardingAddresses/${userEmail}`
  );
  return res.data;
}

export const getBetaListForwardingAddressesQuery = (userEmail: string) => {
  return queryOptions({
    queryKey: [UserKeys.ForwardingAddresses, userEmail],
    queryFn: () => betaListForwardingAddresses(userEmail),
    retry: false,
    staleTime: 0,
    meta: {
      errorMessage: Messages.Errors.Network.Loading(
        'the users forwarding addresses'
      ),
    },
  });
};

export async function deleteForwardingAddress(
  model: ForwardingAddressModel[],
  userEmail: string,
  changeLogMessage: string
) {
  const res = await instance.delete<void>(
    `/api/users/forwardingAddresses/${userEmail}`,
    {
      data: model,
      params: {
        changeLogMessage,
      },
    }
  );
  return res.data;
}

export async function createForwardingAddress(
  model: ForwardingAddressModel,
  userEmail: string,
  changeLogMessage: string
) {
  const res = await instance.post<ForwardingAddressModel>(
    `/api/users/forwardingAddresses/${userEmail}`,
    model,
    {
      params: {
        changeLogMessage,
      },
    }
  );
  return res.data;
}

export async function betaGetGmailImapSettings(userEmail: string) {
  const res = await instance.get<ImapSettingsModel>(
    `/api/users/imapSettings/${userEmail}`
  );
  return res.data;
}

export async function betaUpdateGmailImapSettings(
  userEmail: string,
  model: ImapSettingsModel,
  changeLogMessage: string
) {
  const res = await instance.put<ImapSettingsModel>(
    `/api/users/imapSettings/${userEmail}`,
    model,
    {
      params: {
        changeLogMessage,
      },
    }
  );
  return res.data;
}

export async function betaGetGmailForwarding(userEmail: string) {
  const res = await instance.get<ForwardingModel>(
    `/api/users/forwarding/${userEmail}`
  );
  return res.data;
}

export async function betaUpdateGmailForwarding(
  userEmail: string,
  model: ForwardingModel,
  changeLogMessage: string
) {
  const res = await instance.put<ForwardingModel>(
    `/api/users/forwarding/${userEmail}`,
    model,
    {
      params: {
        changeLogMessage,
      },
    }
  );
  return res.data;
}

export async function betaGetGmailPopSettings(userEmail: string) {
  const res = await instance.get<PopSettingsModel>(
    `/api/users/popSettings/${userEmail}`
  );
  return res.data;
}

export async function betaUpdateGmailPopSettings(
  userEmail: string,
  model: PopSettingsModel,
  changeLogMessage: string
) {
  const res = await instance.put<PopSettingsModel>(
    `/api/users/popSettings/${userEmail}`,
    model,
    {
      params: {
        changeLogMessage,
      },
    }
  );
  return res.data;
}

export async function betaGetGmailSendAs(userEmail: string) {
  const res = await instance.get<SendAsModel[]>(
    `/api/users/sendAs/${userEmail}`
  );
  return res.data;
}

export async function getGmailSendAsForSignatures(userEmail: string) {
  const res = await instance.get<SendAsModel[]>(
    `/api/signatures/sendAsForSignatures/${userEmail}`
  );
  return res.data;
}

export async function betaAddSendAs(
  selectedUser: string,
  model: SendAsModel,
  changeLogMessage: string
) {
  const res = await instance.post<SendAsModel>(
    `/api/users/sendAs/${selectedUser}`,
    model,
    {
      params: {
        changeLogMessage,
      },
    }
  );
  return res.data;
}

export async function betaUpdateSendAs(
  selectedUser: string,
  model: SendAsModel
) {
  const res = await instance.put<SendAsModel>(
    `/api/users/sendAs/${selectedUser}`,
    model
  );
  return res.data;
}

export async function deleteSendAs(
  userEmail: string,
  sendAsEmail: string,
  changeLogMessage: string
) {
  const res = await instance.delete<void>(`/api/users/sendAs/${userEmail}`, {
    data: sendAsEmail,
    params: {
      changeLogMessage,
    },
  });
  return res.data;
}

export async function betaGetGmailVacationMessage(userEmail: string) {
  const res = await instance.get<VacationModel>(
    `/api/users/vacationResponder/${userEmail}`
  );
  return res.data;
}

export async function betaUpdateGmailVacationmessage(
  userEmail: string,
  model: VacationModel,
  changeLogMessage: string
) {
  const res = await instance.put<void>(
    `/api/users/vacationResponder/${userEmail}`,
    model,
    {
      params: {
        changeLogMessage,
      },
    }
  );
  return res.data;
}

export async function betaAddGmailFilter(
  userEmail: string,
  model: Partial<FilterModel>,
  changeLogMessage: string,
  applyToExisting: boolean
) {
  const res = await instance.post<FilterModel>(
    `/api/users/filters/${userEmail}`,
    model,
    {
      params: {
        changeLogMessage,
        applyToExisting,
      },
    }
  );
  return res.data;
}

export async function getSignatures(data: Page<SignatureModel[]>) {
  const res = await instance.post<Page<SignatureModel[]>>(
    `/api/signatures`,
    data,
    {
      params: {
        pageSize: data.pageSize,
      },
    }
  );
  return res.data;
}

export async function getAllSignatures() {
  const res = await instance.get<SignatureModel[]>(`/api/signatures`);
  return res.data;
}

export async function getSignatureLogs(
  data: Page<SignatureRunLog[]>,
  signatureId: number
) {
  const res = await instance.post<Page<SignatureRunLog[]>>(
    '/api/signatures/getSignatureLogs',
    data,
    {
      params: {
        pageSize: data.pageSize,
        signatureId,
      },
    }
  );
  return res.data;
}

export async function getSignatureWithValues(data: SignatureRequestBody) {
  const res = await instance.post<SignaturePopulationResponse>(
    `/api/signatures/populateTemplate`,
    data
  );
  return res.data;
}

export async function getCustomSchemas() {
  const res = await instance.get<CustomSchemaEntity[]>(
    '/api/users/customSchema'
  );
  return res.data;
}

export async function getCustomSchemasUserPortal() {
  const res = await instance.get<CustomSchemaEntity[]>(
    '/api/userPortal/users/customSchema'
  );
  return res.data;
}

export async function updateCustomSchemas(formData: Partial<User>) {
  const res = await instance.put<void>('/api/users/customSchema', formData);
  return res.data;
}

export async function updateCustomSchemasUserPortal(formData: Partial<User>) {
  const res = await instance.put<void>(
    '/api/userPortal/users/customSchema',
    formData
  );
  return res.data;
}

export async function updateGmailSignature(
  userEmail: string,
  sendAsEmail: string,
  signature: string,
  changeLogMessage: string
) {
  const res = await instance.put<void>(
    `/api/users/signatures/${userEmail}`,
    signature,
    {
      params: {
        sendAsEmail,
        changeLogMessage,
      },
    }
  );

  return res.data;
}

export async function startLogSearch(
  searchOptions: Partial<AppLogSearch>,
  firebaseId: string
) {
  const res = await instance.post<void>(
    `/api/logging/start-task`,
    searchOptions,
    {
      params: {
        firebaseId,
      },
    }
  );
  return res.data;
}

export async function getAppLogs(
  target: string,
  cursor: string,
  startDate: number,
  endDate: number
) {
  const res = await instance.get<Page<AppLog[]>>(`/api/logging/user-logs`, {
    params: {
      target,
      nextLink: cursor,
      startDate,
      endDate,
    },
  });
  return res.data;
}

export async function addToGlobalBlockList(userEmail: string) {
  const res = await instance.put<void>(`/api/policies/blockUser/${userEmail}`);
  return res.data;
}

export async function removeFromGlobalBlockList(userEmail: string) {
  const res = await instance.put<void>(
    `/api/policies/removeBlockedUser/${userEmail}`
  );
  return res.data;
}

export async function checkIfInGlobalBlockList(userEmail: string) {
  const res = await instance.get<boolean>(
    `/api/policies/checkList/${userEmail}`
  );
  return res.data;
}

export async function bulkAddToGroup(
  sourceType: string,
  targets: string[],
  groupEmail: string,
  role: string,
  changeLogMessage: string
) {
  const res = await instance.post<void>(`/api/users/bulkAddToGroup`, targets, {
    params: {
      sourceType,
      groupEmail,
      role,
      changeLogMessage,
    },
  });
  return res.data;
}

export async function bulkRemoveFromGroup(
  sourceType: string,
  targets: string[],
  groupEmail: string,
  changeLogMessage: string
) {
  const res = await instance.post<void>(
    `/api/users/bulkRemoveFromGroup`,
    targets,
    {
      params: {
        sourceType,
        groupEmail,
        changeLogMessage,
      },
    }
  );
  return res.data;
}

export async function bulkSuspendUsers(
  sourceType: string,
  targets: string[],
  changeLogMessage: string
) {
  const res = await instance.post<void>(
    `/api/users/bulkSuspendUsers`,
    targets,
    {
      params: {
        sourceType,
        changeLogMessage,
      },
    }
  );
  return res.data;
}

export async function bulkUnSuspendUsers(
  sourceType: string,
  targets: string[],
  changeLogMessage: string
) {
  const res = await instance.post<void>(
    `/api/users/bulkUnSuspendUsers`,
    targets,
    {
      params: {
        sourceType,
        changeLogMessage,
      },
    }
  );
  return res.data;
}

export async function bulkSignOutUsers(
  sourceType: string,
  targets: string[],
  changeLogMessage: string
) {
  const res = await instance.post<void>(
    `/api/users/bulkSignOutUsers`,
    targets,
    {
      params: {
        sourceType,
        changeLogMessage,
      },
    }
  );
  return res.data;
}

export async function bulkForcePasswordReset(
  sourceType: string,
  targets: string[],
  changeLogMessage: string
) {
  const res = await instance.post<void>(
    `/api/users/bulkForcePasswordReset`,
    targets,
    {
      params: {
        sourceType,
        changeLogMessage,
      },
    }
  );
  return res.data;
}

export async function bulkShareContact(
  sourceType: string,
  targets: string[],
  setContactSharing: boolean,
  changeLogMessage: string
) {
  const res = await instance.post<void>(
    `/api/users/bulkShareContact`,
    targets,
    {
      params: {
        sourceType,
        setContactSharing,
        changeLogMessage,
      },
    }
  );
  return res.data;
}

export async function bulkChangeGpanelRole(
  sourceType: string,
  targets: string[],
  gPanelRole: string,
  changeLogMessage: string
) {
  const res = await instance.post<void>(
    `/api/users/bulkChangeGpanelRole`,
    targets,
    {
      params: {
        sourceType,
        gPanelRole,
        changeLogMessage,
      },
    }
  );
  return res.data;
}

export async function bulkDeleteUsers(
  sourceType: string,
  targets: string[],
  createNewUserNames: boolean,
  changeLogMessage: string
) {
  const res = await instance.delete<void>(`/api/users/bulkDeleteUsers`, {
    data: targets,
    params: {
      sourceType,
      createNewUserNames,
      changeLogMessage,
    },
  });
  return res.data;
}

export async function bulkSetOrganization(
  sourceType: string,
  targets: string[],
  orgUnitPath: string,
  changeLogMessage: string
) {
  const res = await instance.post<void>(
    `/api/organizations/bulkSetOrganization`,
    targets,
    {
      params: {
        sourceType,
        orgUnitPath,
        changeLogMessage,
      },
    }
  );
  return res.data;
}

export async function bulkSetImap(
  sourceType: string,
  targets: string[],
  imapEnabled: boolean,
  changeLogMessage: string
) {
  const res = await instance.post<void>(`/api/users/bulkSetImap`, targets, {
    params: {
      sourceType,
      imapEnabled,
      changeLogMessage,
    },
  });
  return res.data;
}

export async function bulkAddGmailLabel(
  sourceType: string,
  targets: string[],
  labelName: string,
  changeLogMessage: string
) {
  const res = await instance.post<void>(
    `/api/users/bulkAddGmailLabel`,
    targets,
    {
      params: {
        sourceType,
        labelName,
        changeLogMessage,
      },
    }
  );
  return res.data;
}

export async function bulkSetPop(
  sourceType: string,
  targets: string[],
  model: GmailPopModel,
  changeLogMessage: string
) {
  const res = await instance.put<void>(`/api/users/bulkSetPop`, model, {
    params: {
      targets,
      sourceType,
      changeLogMessage,
    },
    paramsSerializer: (params) => {
      return qs.stringify(params, { arrayFormat: 'repeat' });
    },
  });
  return res.data;
}

export async function removeProfilePicture(
  userEmail: string,
  changeLogMessage: string
) {
  const res = await instance.delete<void>(`/api/users/removeProfilePicture`, {
    params: {
      userEmail,
      changeLogMessage,
    },
  });
  return res.data;
}

export async function editProfilePicture(
  userEmail: string,
  file: File,
  changeLogMessage: string
) {
  const form = new FormData();
  form.append('upload', file);

  const res = await instance.post<string>(
    `/api/users/${userEmail}/photo`,
    form,
    {
      params: {
        changeLogMessage,
      },
    }
  );
  return res.data;
}

export async function runBulkReport(
  sourceEmails: string[],
  report: string,
  sourceType: string,
  reportModel: Partial<ReportModel>,
  changeLogMessage: string
) {
  const res = await instance.post<string>(
    `/api/reports/runBulkReport`,
    reportModel,
    {
      params: {
        report,
        sourceEmails,
        sourceType,
        changeLogMessage,
      },
      paramsSerializer: (params) => {
        return qs.stringify(params, { arrayFormat: 'repeat' });
      },
    }
  );
  return res.data;
}

export async function updateContact(
  userEmail: string,
  updatedModel: FormPerson,
  changeLogMessage: string
) {
  delete updatedModel.metadata;
  const res = await instance.put<Person>(
    `/api/contacts/updateContact`,
    {
      ...updatedModel,
    },
    {
      params: {
        userEmail,
        changeLogMessage,
      },
    }
  );
  return res.data;
}

export async function updateContactUserPortal(updatedModel: FormPerson) {
  delete updatedModel.metadata;
  const res = await instance.put<Person>(
    '/api/userPortal/contacts/updateContact',
    {
      ...updatedModel,
    }
  );
  return res.data;
}

export async function logClientError(
  error: Error,
  section: string,
  url: string,
  errorType: ErrorType = 'error',
  details?: Record<string, string>
) {
  const res = await instance.post<void>(`/api/greeting/logClientError`, {
    message: error.message,
    stack: error.stack,
    section: section,
    url: url,
    type: errorType,
    ...(details ? { details } : {}),
  });
  return res.data;
}

export async function getSharedDrivesForUser(
  userEmail: string,
  data: Page<SharedDriveModel[]>
) {
  const res = await instance.post<Page<SharedDriveModel[]>>(
    `/api/shared-drives/getPageOfSharedDrivesForUser`,
    data,
    {
      params: {
        userEmail,
      },
    }
  );
  return res.data;
}

export async function getAllSharedDrivesForUser(
  userEmail: string,
  changeLogMessage?: string
) {
  const res = await instance.get<SharedDriveModel[]>(
    `/api/shared-drives/getAllSharedDrivesForUser`,
    {
      params: {
        userEmail,
        changeLogMessage,
      },
    }
  );
  return res.data;
}

export async function copySharedDriveId(
  sharedDriveName: string,
  changeLogMessage?: string
) {
  await instance.post<void>(`/api/shared-drives/copySharedDriveId`, null, {
    params: {
      sharedDriveName,
      changeLogMessage,
    },
  });
}

// no logging and permission check
export async function getPageOfSharedDrivesForDomain(
  page: Page<SharedDriveModel[]>,
  searchTerm: string,
  driveId: string
) {
  const res = await instance.post<Page<SharedDriveModel[]>>(
    `/api/shared-drives/getQueriedPageOfSharedDrivesForDomain`,
    page,
    {
      params: { searchTerm, driveId },
    }
  );
  return res.data;
}

// has logging and permission check
export async function getPageOfSharedDrivesForDomainV2(
  page: Page<SharedDriveModel[]>,
  searchTerm: string,
  driveId: string,
  changeLogMessage?: string
) {
  const res = await instance.post<Page<SharedDriveModel[]>>(
    `/api/shared-drives/getQueriedPageOfSharedDrivesForDomainV2`,
    page,
    {
      params: { searchTerm, driveId, changeLogMessage },
    }
  );
  return res.data;
}

export async function getAllSharedDrivesForDomain(changeLogMessage?: string) {
  const res = await instance.get<SharedDriveModel[]>(
    `/api/shared-drives/getAllSharedDrivesForDomain`,
    {
      params: {
        changeLogMessage,
      },
    }
  );
  return res.data;
}

export async function getSharedDrivesForQuery(query: string) {
  const res = await instance.get<SharedDriveModel>(
    `/api/shared-drives/search`,
    {
      params: {
        query,
      },
    }
  );
  return res.data;
}

export async function getIndexedSharedDrivesWithChangeLog(
  page: BigQueryPage<SharedDriveModel[]>,
  filters: GridFilterModel,
  sortItems: GridSortModel,
  changeLogMessage: string
) {
  const body: {
    page: BigQueryPage<SharedDriveModel[]>;
    filters: GridFilterModel;
    sortItems: GridSortModel;
  } = {
    page,
    filters,
    sortItems,
  };
  const res = await instance.post<BigQueryPage<SharedDriveModel[]>>(
    `/api/shared-drives/getIndexedPageOfSharedDrivesForDomainV2`,
    body,
    {
      params: {
        changeLogMessage,
      },
    }
  );
  return res.data;
}

export async function getIndexedSharedDrives(
  page: BigQueryPage<SharedDriveModel[]>,
  filters: GridFilterModel,
  sortItems: GridSortModel
) {
  const body: {
    page: BigQueryPage<SharedDriveModel[]>;
    filters: GridFilterModel;
    sortItems: GridSortModel;
  } = {
    page,
    filters,
    sortItems,
  };
  const res = await instance.post<BigQueryPage<SharedDriveModel[]>>(
    `/api/shared-drives/getIndexedPageOfSharedDrivesForDomain`,
    body
  );
  return res.data;
}

export async function getIndexedSharedDrivesForAutocomplete(
  page: BigQueryPage<SharedDriveModel[]>,
  name: string
) {
  const res = await instance.post<BigQueryPage<SharedDriveModel[]>>(
    `/api/shared-drives/getIndexedSharedDrivesForAutocomplete`,
    page,
    {
      params: {
        name,
      },
    }
  );
  return res.data;
}

export async function getIndexedOrganizationsForAutocomplete(
  page: BigQueryPage<OrgUnitModel[]>,
  name: string
) {
  const res = await instance.post<OrgUnitModel[]>(
    `/api/organizations/getIndexedOrganizationsForAutocomplete`,
    page,
    {
      params: {
        name,
      },
    }
  );
  return res.data;
}

export async function getIndexedUsers(
  page: BigQueryPage<UserListEntity[]>,
  filters: GridFilterModel,
  sortItems: GridSortModel
) {
  const body: {
    page: BigQueryPage<UserListEntity[]>;
    filters: GridFilterModel;
    sortItems: GridSortModel;
  } = {
    page,
    filters,
    sortItems,
  };
  const res = await instance.post<BigQueryPage<UserListEntity[]>>(
    `/api/users/indexedUserList`,
    body
  );
  return res.data;
}

export async function getIndexedGroupsForAutocomplete(
  page: BigQueryPage<Group[]>,
  name: string
) {
  const res = await instance.post<BigQueryPage<Group[]>>(
    `/api/groups/getIndexedGroupsForAutocomplete`,
    page,
    {
      params: {
        name,
      },
    }
  );
  return res.data;
}

export async function getAllBigQueryGroupsCount() {
  const res = await instance.get<number>(
    `/api/groups/getAllBigQueryGroupsCount`
  );
  return res.data;
}

export async function getAllBigQueryUsersCount() {
  const res = await instance.get<number>(`/api/users/userCount/bigqueryUsers`);
  return res.data;
}

export function getAllSharedDrivesForDomainQuery(options?: {
  enabled?: boolean;
  staleTime?: number;
  changeLogMessage?: string;
}) {
  return queryOptions({
    queryKey: [UserKeys.SharedDrivesForDomain, options?.changeLogMessage ?? ''],
    queryFn: () => getAllSharedDrivesForDomain(options?.changeLogMessage),
    meta: {
      errorMessage: Messages.Errors.Network.Loading('shared drives'),
    },
    ...options,
  });
}

export async function createSharedDriveAsAdmin(
  name: string,
  changeLogMessage: string
) {
  const res = await instance.post<SharedDriveModel>(
    `/api/shared-drives/createDriveAsAdmin`,
    null,
    {
      params: {
        name,
        changeLogMessage,
      },
    }
  );
  return res.data;
}

export async function createSharedDriveAsUser(
  name: string,
  userEmail: string,
  changeLogMessage: string
) {
  const res = await instance.post<SharedDriveModel>(
    `/api/shared-drives/createDriveAsUser`,
    null,
    {
      params: {
        name,
        userEmail,
        changeLogMessage,
      },
    }
  );
  return res.data;
}

export async function renameSharedDrive(
  driveId: string,
  newName: string,
  changeLogMessage: string
) {
  const res = await instance.put<void>(`/api/shared-drives/rename`, null, {
    params: {
      id: driveId,
      newName,
      changeLogMessage,
    },
  });
  return res.data;
}

export async function deleteSharedDrive(
  driveId: string,
  userEmail: string,
  useDomainAdminAccess: boolean,
  changeLogMessage: string
) {
  const res = await instance.delete<void>(`/api/shared-drives/deleteDrive`, {
    params: {
      driveId,
      userEmail,
      useDomainAdminAccess,
      changeLogMessage,
    },
  });
  return res.data;
}

export async function updateSharedDrive(
  userEmail: string,
  data: Partial<SharedDriveModel>,
  changeLogMessage: string
) {
  const res = await instance.put<void>(`/api/shared-drives/updateDrive`, data, {
    params: {
      userEmail,
      changeLogMessage,
    },
  });
  return res.data;
}

export async function getSharedDriveAcls(
  docId: string,
  docOwnerEmail: string,
  mimeType: string
) {
  const res = await instance.get<GPanelPermissionsModel[]>(
    `/api/shared-drives-permissions/acls`,
    {
      params: {
        docId,
        docOwnerEmail,
        mimeType,
      },
    }
  );
  return res.data;
}

export async function getUserPermission(
  driveId: string,
  userEmail: string,
  isSharedDrive: boolean
) {
  const res = await instance.get<string | null>(
    `/api/shared-drives-permissions/getUserPermission`,
    {
      params: {
        driveId,
        userEmail,
        isSharedDrive,
      },
    }
  );
  return res.data;
}

export async function updateSharedDriveAcls(
  docId: string,
  docOwnerEmail: string,
  mimeType: string,
  changes: GPanelPermissionsModel[],
  docTitle: string,
  changeLogMessage: string
) {
  interface GPanelPermissionsModelMap {
    [userEmail: string]: GPanelPermissionsModel;
  }

  const combinedObject: GPanelPermissionsModelMap = {};

  changes.forEach((change) => {
    combinedObject[change.userEmail!] = change;
  });

  // true when 10+ changes were handed to a background task
  const res = await instance.post<boolean>(
    `/api/shared-drives-permissions/acls`,
    combinedObject,
    {
      params: {
        docId,
        docOwnerEmail,
        mimeType,
        docTitle,
        changeLogMessage,
      },
    }
  );
  return res.data;
}

export async function loggedInUserHasAtleastRoleForDrive(
  fileId: string,
  role: string
) {
  const res = await instance.get<boolean>(
    `/api/shared-drives-permissions/loggedInUserHasAtleastRoleForDrive`,
    {
      params: {
        fileId,
        role,
      },
    }
  );
  return res.data;
}

export async function addLoggedInUserAclToDrive(driveId: string, role: string) {
  const res = await instance.post<void>(
    `/api/shared-drives-permissions/addLoggedInUserAclToDrive`,
    null,
    {
      params: {
        driveId,
        role,
      },
    }
  );
  return res.data;
}

export async function getPageOfSharedDriveFiles(
  page: Page<Doc[]>,
  parentId: string,
  driveColumns: string,
  sortDirection: string
) {
  const res = await instance.post<Page<Doc[]>>(
    `/api/shared-drives/getPageOfFiles`,
    page,
    {
      params: {
        parentId,
        driveColumns,
        sortDirection,
      },
    }
  );
  return res.data;
}

export async function getPageOfSharedDriveFolders(
  page: Page<Folder[]>,
  parentId: string,
  driveColumns: string,
  sortDirection: string
) {
  const res = await instance.post<Page<Folder[]>>(
    `/api/shared-drives/getPageOfFolders`,
    page,
    {
      params: {
        parentId,
        driveColumns,
        sortDirection,
      },
    }
  );
  return res.data;
}

export async function getAllSharedDriveFolders(
  parentId: string,
  driveColumns: string,
  sortDirection: string
) {
  const res = await instance.get<Folder[]>(`/api/shared-drives/getAllFolders`, {
    params: {
      parentId,
      driveColumns,
      sortDirection,
    },
  });
  return res.data;
}

export async function getSharedDriveById(driveId: string) {
  const res = await instance.get<SharedDriveModel>(
    `/api/shared-drives/getDriveById`,
    {
      params: {
        driveId,
      },
    }
  );
  return res.data;
}

export async function createSharedDriveFolder(
  parentId: string,
  name: string,
  changeLogMessage: string
) {
  const res = await instance.post<string>(
    `/api/shared-drives/createFolder`,
    null,
    {
      params: {
        parentId,
        name,
        changeLogMessage,
      },
    }
  );
  return res.data;
}

export async function renameSharedDriveDoc(
  docId: string,
  newTitle: string,
  changeLogMessage: string
) {
  const res = await instance.put<void>(`/api/shared-drives/renameDoc`, null, {
    params: {
      docId,
      newTitle,
      changeLogMessage,
    },
  });
  return res.data;
}

export async function moveSharedDriveFiles(
  docList: Doc[],
  newParentId: string,
  changeLogMessage: string
) {
  const res = await instance.put<{ success: boolean; message: string }>(
    `/api/shared-drives/moveSharedDriveFiles`,
    docList,
    {
      params: {
        newParentId,
        changeLogMessage,
      },
    }
  );

  return res.data;
}

export async function moveSharedDriveDocs(
  docList: Doc[],
  newParentId: string,
  changeLogMessage: string
) {
  const res = await instance.put<void>(
    `/api/shared-drives/moveDriveFiles`,
    docList,
    {
      params: {
        newParentId,
        changeLogMessage,
      },
    }
  );

  return res.data;
}

export async function createGroup(
  data: DirectoryGroup,
  groupTemplateId: string | null,
  changeLogMessage: string
) {
  const res = await instance.post<DirectoryGroup>(
    `/api/groups/createGroup`,
    data,
    {
      params: {
        changeLogMessage,
        groupTemplateId,
      },
    }
  );
  return res.data;
}

export async function createCloudIdentityGroup(
  groupPayload: cloudidentity_v1.Schema$Group,
  groupTemplateId: string | null,
  changeLogMessage: string
) {
  const res = await instance.post<cloudidentity_v1.Schema$Operation>(
    `/api/groups/createCloudIdentityGroup`,
    groupPayload,
    {
      params: {
        changeLogMessage,
        groupTemplateId,
      },
    }
  );
  return res.data;
}

export async function bulkDeleteGroups(
  targets: string[],
  sourceType: string,
  changeLogMessage: string
) {
  const res = await instance.delete<void>(`/api/groups/bulkDeleteGroups`, {
    data: targets,
    params: {
      sourceType,
      changeLogMessage,
    },
  });
  return res.data;
}

export async function bulkApplyGroupTemplate(
  targetGroupIds: Record<string, string>,
  groupTemplateId: number,
  changeLogMessage: string
) {
  const res = await instance.put<void>(
    `/api/groups/bulkApplyGroupTemplate`,
    targetGroupIds,
    {
      params: {
        groupTemplateId,
        changeLogMessage,
      },
    }
  );
  return res.data;
}

export async function cloneGroup(cloneGroupRequest: CloneGroupRequest) {
  const res = await instance.post<DirectoryGroup>(
    `/api/groups/cloneGroup`,
    cloneGroupRequest
  );
  return res.data;
}

export async function getAllGroupTemplates() {
  const res = await instance.get<GroupTemplate[]>(
    `/api/groupTemplates/getAllGroupTemplates`
  );
  return res.data;
}

export async function getUserPortalAllGroupTemplates() {
  const res = await instance.get<GroupTemplate[]>(
    `/api/userPortal/groups/getAllGroupTemplates`
  );
  return res.data;
}

export async function getPageOfGroups(data: Page<DirectoryGroup[]>) {
  const res = await instance.post<Page<DirectoryGroup[]>>(
    `/api/groups/pageOfGroups`,
    data
  );
  return res.data;
}

export async function getDirectoryGroup(groupEmail: string) {
  const res = await instance.get<DirectoryGroup>(
    `/api/groups/getDirectoryGroup`,
    {
      params: {
        groupEmail,
      },
    }
  );
  return res.data;
}

export async function getUserPortalDirectoryGroup(groupEmail: string) {
  const res = await instance.get<DirectoryGroup>(
    `/api/userPortal/groups/getDirectoryGroup`,
    {
      params: {
        groupEmail,
      },
    }
  );
  return res.data;
}

export async function groupExistsCheck(groupEmail: string) {
  const res = await instance.get<boolean>(`/api/groups/groupExistsCheck`, {
    params: {
      groupEmail,
    },
  });
  return res.data;
}

export function getDirectoryGroupQuery(groupEmail: string, userView?: boolean) {
  return queryOptions({
    queryKey: [UserKeys.DirectoryGroup, groupEmail, userView],
    queryFn: () =>
      userView
        ? getUserPortalDirectoryGroup(groupEmail)
        : getDirectoryGroup(groupEmail),
    meta: {
      errorMessage: Messages.Errors.Network.Loading('the directory group'),
    },
  });
}

export async function deleteGroup(
  groupEmail: string,
  changeLogMessage: string
) {
  const res = await instance.delete<void>(`/api/groups/deleteGroup`, {
    data: groupEmail,
    params: {
      changeLogMessage,
    },
  });
  return res.data;
}

export async function deleteGroupTemplate(
  model: GroupTemplate,
  changeLogMessage: string
) {
  const res = await instance.delete<void>(
    `/api/groupTemplates/deleteGroupTemplate`,
    {
      data: model,
      params: {
        changeLogMessage,
      },
    }
  );
  return res.data;
}

export async function bulkDeleteGroupTemplates(
  targets: GroupTemplate[],
  changeLogMessage: string
) {
  const res = await instance.delete<void>(
    `/api/groupTemplates/bulkDeleteGroupTemplates`,
    {
      data: targets,
      params: {
        changeLogMessage,
      },
    }
  );
  return res.data;
}

export async function saveGroupTemplate(
  model: GroupTemplate,
  changeLogMessage: string
) {
  const res = await instance.post<GroupTemplate>(
    `/api/groupTemplates/saveGroupTemplate`,
    model,
    {
      params: {
        changeLogMessage,
      },
    }
  );
  return res.data;
}

export async function editGroupTemplate(
  model: GroupTemplate,
  changeLogMessage: string
) {
  const res = await instance.put<void>(
    `/api/groupTemplates/editGroupTemplate`,
    model,
    {
      params: {
        changeLogMessage,
      },
    }
  );
  return res.data;
}

export async function getGroupSettings(groupEmail: string) {
  const res = await instance.get<{ object: GroupBusinessSettings }>(
    `/api/groups/getGroupSettings`,
    {
      params: {
        groupEmail,
      },
    }
  );
  return res.data.object;
}

export async function getUserPortalGroupSettings(groupEmail: string) {
  const res = await instance.get<{ object: GroupBusinessSettings }>(
    `/api/userPortal/groups/getGroupSettings`,
    {
      params: {
        groupEmail,
      },
    }
  );
  return res.data.object;
}

export async function getGroupSecuritySettings(
  groupEmail: string,
  groupId: string
) {
  const res = await instance.get<GroupSecuritySettingsModel>(
    `/api/groups/getGroupSecuritySettings`,
    {
      params: {
        groupEmail,
        groupId,
      },
    }
  );
  return res.data;
}

export async function getGroupLabels(groupEmail: string, groupId: string) {
  const res = await instance.get<{
    [key: string]: string;
  }>(`/api/groups/getGroupLabels`, {
    params: {
      groupEmail,
      groupId,
    },
  });
  return res.data;
}

export function groupSettingsQuery(groupEmail: string, userView?: boolean) {
  return queryOptions({
    queryKey: [UserKeys.GroupSettings, groupEmail, userView],
    queryFn: () =>
      userView
        ? getUserPortalGroupSettings(groupEmail)
        : getGroupSettings(groupEmail),
    meta: {
      errorMessage: Messages.Errors.Network.Loading('group settings'),
    },
  });
}

export function groupSecuritySettingsQuery(
  groupEmail: string,
  groupId: string
) {
  return queryOptions({
    queryKey: [UserKeys.GroupSecuritySettings, groupEmail],
    queryFn: () => getGroupSecuritySettings(groupEmail, groupId),
    meta: {
      errorMessage: Messages.Errors.Network.Loading('group security settings'),
    },
  });
}

export function getGroupLabelsQuery(groupEmail: string, groupId: string) {
  return queryOptions({
    queryKey: [UserKeys.GroupLabels, groupEmail],
    queryFn: () => getGroupLabels(groupEmail, groupId),
    meta: {
      errorMessage: Messages.Errors.Network.Loading('group labels'),
    },
  });
}

export async function saveGroupSecuritySettings(
  securitySettings: GroupSecuritySettingsModel
) {
  const body = {
    securityQuery: securitySettings.memberRestriction.query,
    groupName: securitySettings.name,
    groupEmail: securitySettings.groupEmail,
    changeLogMessage: securitySettings.changeLogMessage,
  };
  const res = await instance.put<GroupSecuritySettingsModel>(
    `/api/groups/saveGroupSecuritySettings`,
    body
  );
  return res.data;
}

export async function saveGroupLabels(
  labels: {
    [key: string]: string;
  },
  groupEmail: string,
  groupId: string,
  changeLogMessage: string
) {
  const res = await instance.put<GroupSecuritySettingsModel>(
    `/api/groups/saveGroupLabels`,
    labels,
    {
      params: {
        groupEmail,
        changeLogMessage,
        groupId,
      },
    }
  );
  return res.data;
}

export async function getCloudIdentityMembers(
  groupEmail: string,
  groupId: string
) {
  const res = await instance.get<cloudidentity_v1.Schema$Membership[]>(
    `/api/groups/getCloudIdentityGroupMembers`,
    {
      params: {
        groupEmail,
        groupId,
      },
    }
  );
  return res.data;
}

export function getCloudIdentityGroupMembers(
  groupEmail: string,
  groupId: string
) {
  return queryOptions({
    queryKey: [UserKeys.GroupMembersCloudIdentity, groupEmail],
    queryFn: () => getCloudIdentityMembers(groupEmail, groupId),
    meta: {
      errorMessage: Messages.Errors.Network.Loading(
        'cloudidentity group members'
      ),
    },
  });
}

export async function modifyCloudIdentityGroupMemberExpiry(
  request: cloudidentity_v1.Schema$ModifyMembershipRolesRequest,
  groupEmail: string,
  groupId: string,
  membershipId: string,
  memberEmail: string,
  changeLogMessage: string
) {
  const res =
    await instance.put<cloudidentity_v1.Schema$ModifyMembershipRolesResponse>(
      `/api/groups/modifyCloudIdentityGroupMemberExpiry`,
      request,
      {
        params: {
          groupId,
          groupEmail,
          membershipId,
          memberEmail,
          changeLogMessage,
        },
      }
    );
  return res.data;
}

export async function modifyCloudIdentityGroupRoles(
  request: CloudIdentityGroupRolesUpdateModel[],
  groupEmail: string
) {
  const res = await instance.put<void>(
    `/api/groups/modifyCloudIdentityGroupRoles`,
    request,
    {
      params: {
        groupEmail,
      },
    }
  );
  return res.data;
}

export async function addMembersToCloudIdentityGroup(
  members: cloudidentity_v1.Schema$Membership[],
  parentGroupId: string,
  parentGroupEmail: string,
  changeLogMessage: string
) {
  const res = await instance.post<void>(
    `/api/groups/addMembersToCloudIdentityGroup`,
    members,
    {
      params: {
        parentGroupId,
        parentGroupEmail,
        changeLogMessage,
      },
    }
  );
  return res.data;
}

export async function saveGroupSettings(
  groupEmail: string,
  newSettings: GroupBusinessSettings,
  currentSettings: GroupBusinessSettings,
  changeLogMessage: string
) {
  const body: {
    groupEmail: string;
    newSettings: GroupBusinessSettings;
    currentSettings: GroupBusinessSettings;
  } = {
    groupEmail,
    newSettings,
    currentSettings,
  };

  const res = await instance.put<GroupBusinessSettings>(
    `/api/groups/saveGroupSettings`,
    body,
    {
      params: {
        changeLogMessage,
      },
    }
  );
  return res.data;
}

export async function indexGroup(
  primaryDomain: string,
  groupEmail: string,
  directoryGroup: DirectoryGroup
) {
  const res = await instance.post<void>(
    `/api/groups/indexGroup`,
    directoryGroup,
    {
      params: {
        primaryDomain,
        groupEmail,
      },
    }
  );
  return res.data;
}

export async function indexGroupBigQuery(
  groupEmail: string,
  changeLogMessage: string
) {
  const res = await instance.post<string>(
    `/api/groups/indexGroupBigQuery`,
    groupEmail,
    {
      params: {
        changeLogMessage,
      },
    }
  );
  return res.data;
}

export async function indexUserBigQuery(
  userEmail: string,
  changeLogMessage: string
) {
  const res = await instance.post<string>(
    `/api/users/indexUserBigQuery`,
    userEmail,
    {
      params: {
        changeLogMessage,
      },
    }
  );
  return res.data;
}

export async function addGroupAlias(
  groupEmail: string,
  alias: string,
  changeLogMessage: string
) {
  const res = await instance.post<void>(`/api/groups/addAliasToGroup`, alias, {
    params: {
      groupEmail,
      changeLogMessage,
    },
  });
  return res.data;
}

export async function deleteGroupAlias(
  groupEmail: string,
  sourceType: string,
  aliasEmails: string[],
  changeLogMessage: string
) {
  const res = await instance.delete<boolean>(
    `/api/groups/removeAliasFromGroup`,
    {
      data: aliasEmails,
      params: {
        groupEmail,
        sourceType,
        changeLogMessage,
      },
    }
  );
  return res.data;
}

export async function getGroupMembers(
  groupEmail: string,
  data: Page<DirectoryGroupMember[]>
) {
  const res = await instance.post<Page<DirectoryGroupMember[]>>(
    `/api/groups/getGroupMembership`,
    data,
    {
      params: {
        groupEmail,
      },
    }
  );
  return res.data;
}

export async function getAllGroupMembers(groupEmail: string) {
  const res = await instance.get<DirectoryGroupMember[]>(
    `/api/groups/getAllGroupMembers`,
    {
      params: {
        groupEmail,
      },
    }
  );
  return res.data;
}

export async function getUserPortalAllGroupMembers(groupEmail: string) {
  const res = await instance.get<DirectoryGroupMember[]>(
    `/api/userPortal/groups/getAllGroupMembers`,
    {
      params: {
        groupEmail,
      },
    }
  );
  return res.data;
}

export async function deleteGroupMembers(
  groupEmail: string,
  sourceType: string,
  userEmails: string[],
  changeLogMessage: string
) {
  const res = await instance.delete<boolean>('/api/groups/deleteGroupMembers', {
    data: userEmails,
    params: {
      groupEmail,
      sourceType,
      changeLogMessage,
    },
  });
  return res.data;
}

export async function deleteGroupMembersUserPortal(
  groupEmail: string,
  sourceType: string,
  userEmails: string[]
) {
  const res = await instance.delete<boolean>(
    '/api/userPortal/groups/deleteGroupMembers',
    {
      data: userEmails,
      params: {
        groupEmail,
        sourceType,
      },
    }
  );
  return res.data;
}

export async function changeMembersRole(
  groupEmail: string,
  sourceType: string,
  members: DirectoryGroupMember[],
  role: string,
  changeLogMessage: string
) {
  const res = await instance.put<boolean>(
    '/api/groups/changeMembersRole',
    members,
    {
      params: {
        groupEmail,
        sourceType,
        role,
        changeLogMessage,
      },
    }
  );
  return res.data;
}

export async function changeMembersRoleUserPortal(
  groupEmail: string,
  sourceType: string,
  members: DirectoryGroupMember[],
  role: string
) {
  const res = await instance.put<boolean>(
    '/api/userPortal/groups/changeMembersRole',
    members,
    {
      params: {
        groupEmail,
        sourceType,
        role,
      },
    }
  );
  return res.data;
}

export async function addMembersToGroup(
  groupEmail: string,
  members: DirectoryGroupMember[],
  changeLogMessage: string
) {
  const res = await instance.post<void>(
    '/api/groups/addMembersToGroup',
    members,
    {
      params: {
        groupEmail,
        changeLogMessage,
      },
    }
  );
  return res.data;
}

export async function addMembersToGroupUserPortal(
  groupEmail: string,
  members: DirectoryGroupMember[]
) {
  const res = await instance.post<void>(
    '/api/userPortal/groups/addMembersToGroup',
    members,
    {
      params: {
        groupEmail,
      },
    }
  );
  return res.data;
}

export async function exportAppLogs(
  appLogSearch: Partial<AppLogSearch>,
  changeLogMessage: string
) {
  const res = await instance.post<string>(
    `/api/logging/exportAppLogs`,
    appLogSearch,
    {
      params: {
        changeLogMessage,
      },
    }
  );
  return res.data;
}

export async function getSharedContacts(
  primaryDomain: string,
  queryString: string,
  data: Page<SharedContactModel[]>,
  pageSize: number
) {
  const res = await instance.post<Page<SharedContactModel[]>>(
    `/api/sharedContacts/getDomainSharedContacts`,
    data,
    {
      params: {
        primaryDomain,
        queryString,
        pageSize,
      },
    }
  );
  return res.data;
}

export async function deleteSharedContacts(
  userEmail: string,
  models: SharedContactModel[],
  sourceType: string,
  changeLogMessage: string
) {
  const res = await instance.delete<boolean>(
    '/api/sharedContacts/deleteContacts',
    {
      data: models,
      params: {
        userEmail,
        sourceType,
        changeLogMessage,
      },
    }
  );
  return res.data;
}

export async function deleteSharedContactsUserPortal(
  userEmail: string,
  models: SharedContactModel[],
  sourceType: string
) {
  const res = await instance.delete<boolean>(
    '/api/userPortal/sharedContacts/deleteContacts',
    {
      data: models,
      params: {
        userEmail,
        sourceType,
      },
    }
  );
  return res.data;
}

export async function addSharedContact(
  userEmail: string,
  contactGroupModel: Partial<SharedContactModel>,
  changeLogMessage: string
) {
  const res = await instance.post<SharedContactModel>(
    '/api/sharedContacts/addContact',
    contactGroupModel,
    {
      params: {
        userEmail,
        changeLogMessage,
      },
    }
  );
  return res.data;
}

export async function addSharedContactUserPortal(
  userEmail: string,
  contactGroupModel: Partial<SharedContactModel>
) {
  const res = await instance.post<SharedContactModel>(
    '/api/userPortal/sharedContacts/addContact',
    contactGroupModel,
    {
      params: {
        userEmail,
      },
    }
  );
  return res.data;
}

export async function updateSharedContact(
  userEmail: string,
  contactGroupModel: SharedContactModel,
  changeLogMessage: string
) {
  const res = await instance.put<SharedContactModel>(
    '/api/sharedContacts/updateContact',
    contactGroupModel,
    {
      params: {
        userEmail,
        changeLogMessage,
      },
    }
  );
  return res.data;
}

export async function updateSharedContactUserPortal(
  userEmail: string,
  contactGroupModel: SharedContactModel
) {
  const res = await instance.put<SharedContactModel>(
    '/api/userPortal/sharedContacts/updateContact',
    contactGroupModel,
    {
      params: {
        userEmail,
      },
    }
  );
  return res.data;
}

export async function getContactSyncsList() {
  const res = await instance.get<ContactSyncModel[]>(
    `/api/contactSync/getContactSyncsList`
  );
  return res.data;
}

export async function deleteContactSync(
  model: ContactSyncModel,
  deleteGroups: boolean,
  changeLogMessage: string
) {
  const res = await instance.delete<void>(
    `/api/contactSync/deleteContactSync`,
    {
      data: model,
      params: {
        deleteGroups,
        changeLogMessage,
      },
    }
  );
  return res.data;
}

export async function runAllContactSyncs() {
  const res = await instance.post<void>(`/api/contactSync/runAllContactSyncs`);
  return res.data;
}

export async function runContactSync(model: ContactSyncModel) {
  const res = await instance.post<void>(
    `/api/contactSync/runContactSync`,
    model
  );
  return res.data;
}

export async function cleanContactSyncGroups(
  model: ContactSyncModel,
  changeLogMessage: string
) {
  const res = await instance.put<void>(
    `/api/contactSync/cleanContactSyncGroups`,
    model,
    {
      params: {
        changeLogMessage,
      },
    }
  );
  return res.data;
}

export async function getContactSyncUserModels(
  data: Page<ContactSyncUserModels[]>,
  contactSyncId: number
) {
  const res = await instance.post<Page<ContactSyncUserModels[]>>(
    `/api/contactSync/getContactSyncUserModels`,
    data,
    {
      params: {
        contactSyncId,
      },
    }
  );
  return res.data;
}

export async function saveContactSync(
  model: Partial<ContactSyncModel>,
  isUpdate: boolean,
  changeLogMessage: string
) {
  const res = await instance.post<number>(
    `/api/contactSync/saveContactSync`,
    model,
    {
      params: {
        isUpdate,
        changeLogMessage,
      },
    }
  );
  return res.data;
}

export async function editContactSync(
  model: Partial<ContactSyncModel>,
  changeLogMessage: string
) {
  const res = await instance.put<number>(
    `/api/contactSync/editContactSync`,
    model,
    {
      params: {
        changeLogMessage,
      },
    }
  );
  return res.data;
}

export async function getContactSyncRunLogs(
  data: Page<ContactSyncRunLog[]>,
  contactSyncId: number
) {
  const res = await instance.get<Page<ContactSyncRunLog[]>>(
    `/api/contactSync/logs`,
    {
      params: {
        pageSize: data.pageSize,
        contactSyncId,
        cursor: data.cursor,
      },
    }
  );
  return res.data;
}

export async function startUserSearchTaskForOrgUnits(
  search: UserSearchFilter,
  timeStamp: string,
  pageSize: number,
  nextLink: string,
  orgUnitPath: string
) {
  const res = await instance.post<
    string | { results: User[] | null; cursor: string | null }
  >(`/api/search/startUserSearchTask`, search, {
    params: {
      timeStamp,
      pageSize,
      nextLink,
      orgUnitPath,
    },
  });
  return res.data;
}

export async function getUsersByOrgUnit(
  orgUnitPath: string,
  searchFilter: string,
  orderBy: 'EMAIL' | 'FAMILY_NAME' | 'GIVEN_NAME',
  sortDirection: 'ASCENDING' | 'DESCENDING',
  pageSize: number,
  nextLink: string
) {
  const res = await instance.get<Page<User[]>>(
    `/api/organizations/getUsersByOrgUnit`,
    {
      params: {
        orgUnitPath,
        searchFilter,
        orderBy,
        sortDirection,
        pageSize,
        nextLink,
      },
    }
  );
  return res.data;
}

export async function getAllIndexedOrgUnits() {
  const res = await instance.get<OrgUnitModel[]>(
    `/api/organizations/getAllIndexedOrgUnits`
  );
  return res.data;
}

export async function listDataTransferLogs(
  data: Page<DataTransferLog[]>,
  pageSize: number
) {
  const res = await instance.post<Page<DataTransferLog[]>>(
    `/api/calendars/listDataTransferLogs`,
    data,
    {
      params: {
        pageSize,
      },
    }
  );
  return res.data;
}

export async function getAllResourceTemplates() {
  const res = await instance.get<ResourceTemplateModel[]>(
    `/api/resourceCalendars/getAllResourceTemplates`
  );
  return res.data;
}

export async function getResourceTemplates(
  data: Page<ResourceTemplateModel[]>
) {
  const res = await instance.post<Page<ResourceTemplateModel[]>>(
    `/api/resourceCalendars/getResourceTemplates`,
    data,
    {
      params: {
        pageSize: data.pageSize,
      },
    }
  );
  return res.data;
}

export async function getResourceTemplateCount() {
  const res = await instance.get<number>(
    `/api/resourceCalendars/getResourceTemplateCount`
  );
  return res.data;
}

export async function deleteResourceTemplate(
  model: ResourceTemplateModel,
  changeLogMessage: string
) {
  const res = await instance.delete<void>(
    `/api/resourceCalendars/deleteResourceTemplate`,
    {
      data: model,
      params: {
        changeLogMessage,
      },
    }
  );
  return res.data;
}

export async function saveResourceTemplate(
  model: Partial<ResourceTemplateModel>,
  changeLogMessage: string
) {
  const res = await instance.post<ResourceTemplateModel>(
    `/api/calendars/saveResourceTemplate`,
    model,
    {
      params: {
        changeLogMessage,
      },
    }
  );
  return res.data;
}

export async function editResourceTemplate(
  model: FormValue,
  changeLogMessage: string
) {
  delete model.building;
  const res = await instance.put<ResourceTemplateModel>(
    `/api/calendars/editResourceTemplate`,
    model,
    {
      params: {
        changeLogMessage,
      },
    }
  );
  return res.data;
}

export async function getListOfBuildings() {
  const res = await instance.get<BuildingsModel[]>(
    `/api/resourceCalendars/getListOfBuildings`
  );
  return res.data;
}

// getAllResourceCalendars with changelog and permission checks
export async function getAllResourceCalendarsWithChangeLog(
  changeLogMessage: string
) {
  const res = await instance.get<ResourceCalendar[]>(
    `/api/resourceCalendars/getAllResourceCalendarsV2`,
    {
      params: {
        changeLogMessage,
      },
    }
  );
  return res.data;
}

// getAllResourceCalendars without changelog and permission checks
export async function getAllResourceCalendars() {
  const res = await instance.get<ResourceCalendar[]>(
    `/api/resourceCalendars/getAllResourceCalendars`
  );
  return res.data;
}

export async function getFeatures() {
  const res = await instance.get<FeatureModel[]>(
    `/api/resourceCalendars/getFeatures`
  );
  return res.data;
}

export async function getResourceCalendarAcls(
  calendar: ResourceCalendar,
  changeLogMessage: string
) {
  const res = await instance.post<CalendarAclResource[]>(
    `/api/resourceCalendars/getResourceAcls`,
    calendar,
    {
      params: {
        changeLogMessage,
      },
    }
  );
  return res.data;
}

export async function createFeature(
  feature: Partial<FeatureModel>,
  changeLogMessage: string
) {
  const res = await instance.post<FeatureModel>(
    `/api/resourceCalendars/createFeature`,
    feature,
    {
      params: {
        changeLogMessage,
      },
    }
  );
  return res.data;
}

export async function deleteResourceCalendar(
  model: ResourceCalendar,
  changeLogMessage: string
) {
  const res = await instance.delete<void>(
    `/api/resourceCalendars/deleteResourceCalendar`,
    {
      data: model,
      params: {
        changeLogMessage,
      },
    }
  );
  return res.data;
}

export async function deleteFeature(
  model: FeatureModel,
  changeLogMessage: string
) {
  const res = await instance.delete<void>(
    `/api/resourceCalendars/deleteFeature`,
    {
      data: model,
      params: {
        changeLogMessage,
      },
    }
  );
  return res.data;
}

export async function updateResourceCalendarAcls(
  userEmail: string,
  calendar: ResourceCalendar,
  changes: CalendarAclResource[],
  changeLogMessage: string
) {
  const res = await instance.put<CalendarAclResource[]>(
    `/api/resourceCalendars/updateResourceAcls`,
    {
      calModel: calendar,
      changes,
    },
    {
      params: {
        userEmail,
        changeLogMessage,
      },
    }
  );
  return res.data;
}

export async function deleteBuilding(
  model: BuildingsModel,
  changeLogMessage: string
) {
  const res = await instance.delete<void>(
    `/api/resourceCalendars/deleteBuilding`,
    {
      data: model,
      params: {
        changeLogMessage,
      },
    }
  );
  return res.data;
}

export async function createBuilding(
  building: Partial<BuildingsModel>,
  changeLogMessage: string
) {
  const res = await instance.post<BuildingsModel>(
    `/api/resourceCalendars/createBuilding`,
    building,
    {
      params: {
        changeLogMessage,
      },
    }
  );
  return res.data;
}

export async function updateBuilding(
  newBuilding: BuildingsModel,
  currentBuilding: BuildingsModel,
  changeLogMessage: string
) {
  const res = await instance.put<BuildingsModel>(
    `/api/resourceCalendars/updateBuilding`,
    {
      newBuilding,
      currentBuilding,
    },
    {
      params: {
        changeLogMessage,
      },
    }
  );
  return res.data;
}

export async function createResourceCalendar(
  calendar: Partial<ResourceCalendar>,
  changeLogMessage: string
) {
  const res = await instance.post<ResourceCalendar>(
    `/api/resourceCalendars/createResourceCal`,
    calendar,
    {
      params: {
        changeLogMessage,
      },
    }
  );
  return res.data;
}

export async function updateResourceCalendar(
  newCalendar: ResourceCalendar,
  currentCalendar: ResourceCalendar,
  changeLogMessage: string
) {
  const res = await instance.put<void>(
    `/api/resourceCalendars/updateResourceCal`,
    {
      newCalendar,
      currentCalendar,
    },
    {
      params: {
        changeLogMessage,
      },
    }
  );
  return res.data;
}

export async function addCalendarShares(
  resourceEmail: string,
  shares: CalendarAclResource[]
) {
  const res = await instance.post<void>(
    `/api/resourceCalendars/addCalendarShares`,
    shares,
    {
      params: {
        resourceEmail,
      },
    }
  );
  return res.data;
}

export async function getListOfResourceCalendarsWithBuilding(
  data: Page<ResourceCalendar[]>,
  buildingId: string
) {
  const res = await instance.post<Page<ResourceCalendar[]>>(
    `/api/resourceCalendars/getBuildingResources`,
    data,
    {
      params: {
        buildingId,
      },
    }
  );
  return res.data;
}

export async function renameFeature(
  oldName: string,
  newName: string,
  changeLogMessage: string
) {
  const res = await instance.put<boolean>(
    `/api/resourceCalendars/renameFeature`,
    newName,
    {
      params: {
        oldName,
        changeLogMessage,
      },
    }
  );
  return res.data;
}

export async function getResourceCalendarEvents(
  calendar: Partial<ResourceCalendar>,
  startTime: number,
  endTime: number,
  changeLogMessage: string = ''
) {
  const res = await instance.post<CalendarEventModel[]>(
    `/api/calendars/resourceCalendarEvents`,
    calendar,
    {
      params: {
        startTime,
        endTime,
        changeLogMessage,
      },
    }
  );
  return res.data;
}

export async function createResourceCalendarEvent(
  calendarId: string,
  sendNotifications: boolean,
  eventModel: Partial<CalendarEventModel>,
  changeLogMessage: string
) {
  const res = await instance.post<CalendarEventModel>(
    `/api/calendars/resourceCalendarEvents/createEvent`,
    eventModel,
    {
      params: {
        calendarId,
        sendNotifications,
        changeLogMessage,
      },
    }
  );

  return res.data;
}

export async function updateResourceCalendarEvent(
  calendarId: string,
  eventId: string,
  sendNotifications: boolean,
  eventModel: Partial<CalendarEventModel>,
  changeLogMessage: string
) {
  const res = await instance.put<CalendarEventModel>(
    `/api/calendars/resourceCalendarEvents/updateEvent`,
    eventModel,
    {
      params: {
        calendarId,
        eventId,
        sendNotifications,
        changeLogMessage,
      },
    }
  );

  return res.data;
}

export async function deleteResourceEvent(
  userEmail: string,
  calendarId: string,
  eventModel: Partial<CalendarEventModel>,
  changeLogMessage: string
) {
  const res = await instance.delete<CalendarEventModel>(
    `/api/calendars/resourceCalendarEvents/deleteEvent`,
    {
      data: eventModel,
      params: {
        userEmail,
        calendarId,
        changeLogMessage,
      },
    }
  );

  return res.data;
}

export async function startDriveSearchTask(
  docSearch: Partial<DocSearchFilter>,
  timeStamp: string,
  isExport: boolean,
  changeLogMessage: string,
  firebaseMessageType: string
) {
  const res = await instance.post<string>(`/api/drive/startSearch`, docSearch, {
    params: {
      timeStamp,
      isExport,
      changeLogMessage,
      firebaseMessageType,
    },
  });
  return res.data;
}

export async function startUserDriveSearchTask(
  docSearch: Partial<DocSearchFilter>,
  timeStamp: string,
  isExport: boolean,
  changeLogMessage: string,
  firebaseMessageType: string
) {
  const res = await instance.post<string>(
    `/api/drive/startSearchUserTab`,
    docSearch,
    {
      params: {
        timeStamp,
        isExport,
        changeLogMessage,
        firebaseMessageType,
      },
    }
  );
  return res.data;
}

export async function disableDevices(
  deviceIds: string[],
  changeLogMessage: string
) {
  const res = await instance.put<void>(
    '/api/chromeDevices/disableDevices',
    deviceIds,
    {
      params: {
        changeLogMessage,
      },
    }
  );
  return res.data;
}

export async function enableDevices(
  deviceIds: string[],
  changeLogMessage: string
) {
  const res = await instance.put<void>(
    '/api/chromeDevices/enableDevices',
    deviceIds,
    {
      params: {
        changeLogMessage,
      },
    }
  );
  return res.data;
}

export async function deprovisionDevices(
  deviceIds: string[],
  deprovisionReason: string,
  changeLogMessage: string
) {
  const res = await instance.put<void>(
    '/api/chromeDevices/deprovisionDevices',
    deviceIds,
    {
      params: {
        deprovisionReason,
        changeLogMessage,
      },
    }
  );
  return res.data;
}

export async function moveChromeDevices(
  orgUnitPath: string,
  model: ChromeOsMoveDevicesToOuModel,
  changeLogMessage: string
) {
  const res = await instance.post<void>(
    '/api/chromeDevices/moveDevices',
    model,
    {
      params: {
        orgUnitPath,
        changeLogMessage,
      },
    }
  );
  return res.data;
}

export async function userPortalGetSharedContacts(
  primaryDomain: string,
  queryString: string,
  data: Page<SharedContactModel[]>,
  pageSize: number
) {
  const res = await instance.post<Page<SharedContactModel[]>>(
    '/api/userPortal/sharedContacts/getDomainSharedContacts',
    data,
    {
      params: {
        primaryDomain,
        queryString,
        pageSize,
      },
    }
  );
  return res.data;
}

export async function isUserOwnerOfGroup(
  userEmail: string,
  groupEmail: string
) {
  const res = await instance.get<boolean>(
    '/api/userPortal/groups/isUserOwnerOfGroup',
    {
      params: {
        userEmail,
        groupEmail,
      },
    }
  );
  return res.data;
}

export async function isUserManagerOfGroup(
  userEmail: string,
  groupEmail: string
) {
  const res = await instance.get<boolean>(
    '/api/userPortal/groups/isUserManagerOfGroup',
    {
      params: {
        userEmail,
        groupEmail,
      },
    }
  );
  return res.data;
}

export async function isUserMemberOfGroup(
  userEmail: string,
  groupEmail: string
) {
  const res = await instance.get<boolean>(
    '/api/userPortal/groups/isUserMemberOfGroup',
    {
      params: {
        userEmail,
        groupEmail,
      },
    }
  );
  return res.data;
}

export async function getRoleOfGroupUserPortal(
  userEmail: string,
  groupEmail: string
) {
  const res = await instance.get<string>(
    '/api/userPortal/groups/getRoleOfGroupUserPortal',
    {
      params: {
        userEmail,
        groupEmail,
      },
    }
  );
  return res.data;
}

export function getRoleOfGroupUserPortalQuery(
  userView: boolean,
  loggedInUser: string,
  groupEmail: string
) {
  return queryOptions({
    queryKey: [UserKeys.GroupSettings, loggedInUser, groupEmail],
    queryFn: () => getRoleOfGroupUserPortal(loggedInUser, groupEmail),
    enabled: userView,
  });
}

export async function deleteGroupUserPortal(groupEmail: string) {
  const res = await instance.delete<void>(
    '/api/userPortal/groups/deleteGroup',
    {
      data: groupEmail,
    }
  );
  return res.data;
}

export async function createGroupUserPortal(
  data: DirectoryGroup,
  groupTemplateId: string | null
) {
  const res = await instance.post<DirectoryGroup>(
    '/api/userPortal/groups/createGroup',
    data,
    {
      params: {
        groupTemplateId,
      },
    }
  );
  return res.data;
}

export async function saveGroupSettingsUserPortal(
  groupEmail: string,
  newSettings: GroupBusinessSettings,
  currentSettings: GroupBusinessSettings
) {
  const body: {
    groupEmail: string;
    newSettings: GroupBusinessSettings;
    currentSettings: GroupBusinessSettings;
  } = {
    groupEmail,
    newSettings,
    currentSettings,
  };

  const res = await instance.put<GroupBusinessSettings>(
    '/api/userPortal/groups/saveGroupSettings',
    body
  );
  return res.data;
}

export async function deleteUserFromGroupsUserPortal(groupEmail: string) {
  const res = await instance.delete<void>(
    '/api/userPortal/groups/removeMemberFromGroup',
    {
      params: {
        groupEmail,
      },
    }
  );
  return res.data;
}

export async function getAllGroupsForUser(userEmail: string) {
  const res = await instance.get<DirectoryGroup[]>(
    `/api/userPortal/users/allGroupsForUser`,
    {
      params: {
        userEmail,
      },
    }
  );
  return res.data;
}

export async function getUserDecomStatus(userEmail: string) {
  const res = await instance.get<DecomSuspendedUserModel>(
    '/api/decom/decomStatus',
    {
      params: {
        userEmail,
      },
    }
  );
  return res.data;
}

export async function pauseDecomForUser(
  userEmail: string,
  changeLogMessage: string
) {
  const res = await instance.put<void>('/api/decom/pauseDecom', userEmail, {
    params: {
      changeLogMessage,
    },
  });
  return res.data;
}

export async function unpauseDecomForUser(
  userEmail: string,
  changeLogMessage: string
) {
  const res = await instance.put<void>('/api/decom/unpauseDecom', userEmail, {
    params: {
      changeLogMessage,
    },
  });
  return res.data;
}

export async function terminateDecomForUser(
  userEmail: string,
  changeLogMessage: string
) {
  const res = await instance.put<void>('/api/decom/terminateDecom', userEmail, {
    params: {
      changeLogMessage,
    },
  });
  return res.data;
}

export async function purgeDecomForUser(
  userEmail: string,
  changeLogMessage: string
) {
  const res = await instance.put<void>('/api/decom/purgeDecom', userEmail, {
    params: {
      changeLogMessage,
    },
  });
  return res.data;
}

export async function getCpanelLogs(
  data: Page<ActivityModel[]>,
  searchOptions: cPanelLogSearchForm
) {
  const res = await instance.post<Page<ActivityModel[]>>(
    '/api/reports/getCpanelLogs',
    data,
    {
      params: {
        pageSize: data.pageSize,
        startDate: searchOptions.startDate,
        endDate: searchOptions.endDate,
        actor: searchOptions.actor,
        ip: searchOptions.ip,
        eventName: searchOptions.eventName,
        orgUnit: searchOptions.orgUnit,
      },
    }
  );
  return res.data;
}
export async function getGmailDeletionModels() {
  const res = await instance.get<GmailDeletionModel[]>(
    '/api/gmailDeletion/getDeletionModelsReact'
  );
  return res.data;
}

export async function exportCpanelLogs(
  searchOptions: cPanelLogSearchForm,
  changeLogMessage: string
) {
  const res = await instance.post<string>(
    '/api/reports/exportCpanelLogs',
    null,
    {
      params: {
        startDate: searchOptions.startDate,
        endDate: searchOptions.endDate,
        actor: searchOptions.actor,
        ipAddress: searchOptions.ip,
        eventName: searchOptions.eventName,
        changeLogMessage,
      },
    }
  );
  return res.data;
}

export async function deleteGmailDeletionModels(
  ids: number[],
  changeLogMessage: string
) {
  const res = await instance.delete<void>(
    '/api/gmailDeletion/deleteDeletionModels',
    {
      data: ids,
      params: {
        changeLogMessage,
      },
    }
  );
  return res.data;
}

export async function saveGmailDeletionModel(
  model: Partial<GmailDeletionModel>,
  changeLogMessage: string
) {
  const res = await instance.post<GmailDeletionModel>(
    '/api/gmailDeletion/createDeletionModel',
    model,
    {
      params: {
        changeLogMessage,
      },
    }
  );
  return res.data;
}

export async function updateGmailDeletionModel(
  model: Partial<GmailDeletionModel>,
  changeLogMessage: string
) {
  const res = await instance.put<GmailDeletionModel>(
    '/api/gmailDeletion/updateDeletionModel',
    model,
    {
      params: {
        changeLogMessage,
      },
    }
  );
  return res.data;
}

export async function runDeletionReport(
  model: GmailDeletionModel,
  changeLogMessage: string
) {
  const res = await instance.post<string>(
    '/api/gmailDeletion/runDeletionReport',
    model,
    {
      params: {
        changeLogMessage,
      },
    }
  );
  return res.data;
}

export async function saveAgreementGmailDeletion(model: GmailDeletionModel) {
  const res = await instance.post<void>(
    '/api/gmailDeletion/saveAgreement',
    model
  );
  return res.data;
}

export async function runGmailDeletion(
  model: GmailDeletionModel,
  spreadsheetId: string,
  changeLogMessage: string
) {
  const res = await instance.post<string>(
    '/api/gmailDeletion/runGmailDeletion',
    model,
    {
      params: {
        spreadsheetId,
        changeLogMessage,
      },
    }
  );
  return res.data;
}

export async function idAccessToken() {
  const res = await instance.get<string>('/api/gmailDeletion/accessToken');
  return res.data;
}

export async function getGmailAuditModels() {
  const res = await instance.get<GmailAuditModel[]>(
    '/api/gmailExport/getGmailExports'
  );
  return res.data;
}

export async function deleteGmailExports(
  models: GmailAuditModel[],
  changeLogMessage: string
) {
  const res = await instance.delete<void>(
    '/api/gmailExport/deleteGmailExports',
    {
      data: models,
      params: {
        changeLogMessage,
      },
    }
  );
  return res.data;
}

export async function checkIfKeyUploaded() {
  const res = await instance.get<GmailExportKey>(
    '/api/gmailExport/checkIfKeyUploaded'
  );
  return res.data;
}

export interface GmailExportDeprecationStatus {
  emailAuditApiAvailable: boolean;
  hasVaultAccess: boolean;
}

export async function getGmailExportDeprecationStatus() {
  const res = await instance.get<GmailExportDeprecationStatus>(
    '/api/gmailExport/deprecation-status'
  );
  return res.data;
}

export async function uploadKey(key: string, changeLogMessage: string) {
  const res = await instance.post<GmailExportKey>(
    '/api/gmailExport/uploadKey',
    null,
    {
      params: {
        key,
        changeLogMessage,
      },
    }
  );
  return res.data;
}

export async function setPublicKey() {
  const res = await instance.put<GmailExportKey>(
    '/api/gmailExport/setPublicKey',
    null
  );
  return res.data;
}

export async function createGmailExport(
  model: Partial<GmailAuditModel>,
  changeLogMessage: string
) {
  const res = await instance.post<void>(
    '/api/gmailExport/createGmailExport',
    model,
    {
      params: {
        changeLogMessage,
      },
    }
  );
  return res.data;
}

export async function downloadGmailExportToDrive(
  model: GmailAuditModel,
  folderName: string,
  folderId: string,
  changeLogMessage: string
) {
  const res = await instance.post<void>(
    '/api/gmailExport/downloadGmailExportToDrive',
    model,
    {
      params: {
        folderName,
        folderId,
        changeLogMessage,
      },
    }
  );
  return res.data;
}

export async function getUsersDirectorySearchUserPortal(
  page: Page<UserSearchEntity[]>,
  searchString: string
) {
  const res = await instance.post<Page<UserSearchEntity[]>>(
    '/api/userPortal/search/directoryUserSearch',
    page,
    {
      params: {
        text: searchString,
        returnSize: page.pageSize,
      },
    }
  );
  return res.data;
}

export async function searchCalendars(searchText: string) {
  const res = await instance.get<CalendarSearch[]>(`/api/search/search`, {
    params: {
      text: searchText,
      returnSize: 5,
    },
  });
  return res.data;
}

export async function deletePolicies(ids: number[], changeLogMessage: string) {
  const res = await instance.delete<void>(`/api/policies/deletePolicies`, {
    data: ids,
    params: {
      changeLogMessage,
    },
  });
  return res.data;
}

export async function createPolicy(
  model: Partial<Policy>,
  changeLogMessage: string
) {
  const res = await instance.post<number>('/api/policies/createPolicy', model, {
    params: {
      changeLogMessage,
    },
  });
  return res.data;
}

export async function editPolicy(
  model: Partial<Policy>,
  changeLogMessage: string
) {
  const res = await instance.put<number>('/api/policies/editPolicy', model, {
    params: {
      changeLogMessage,
    },
  });
  return res.data;
}

export async function clonePolicy(
  model: Partial<Policy>,
  originalName: string,
  changeLogMessage: string
) {
  const res = await instance.post<number>('/api/policies/clonePolicy', model, {
    params: {
      originalName,
      changeLogMessage,
    },
  });
  return res.data;
}

export async function runPolicy(model: Policy, changeLogMessage: string) {
  const res = await instance.post<number>('/api/policies/runPolicy', model, {
    params: {
      changeLogMessage,
    },
  });
  return res.data;
}

export async function runPolicies(ids: number[], changeLogMessage: string) {
  const res = await instance.post<number>('/api/policies/runPolicies', ids, {
    params: {
      changeLogMessage,
    },
  });
  return res.data;
}

export async function getGmailFilters(userEmail: string) {
  const res = await instance.get<FilterModel[]>(
    `/api/users/filters/${userEmail}`
  );
  return res.data;
}

export async function checkMatchingEmails(userEmail: string, query: string) {
  const res = await instance.get<MailIdModel[]>(
    `/api/users/mails/${userEmail}`,
    {
      params: { query },
    }
  );
  return res.data;
}

export async function deleteGmailFilters(
  userEmail: string,
  filters: string[],
  changeLogMessage: string
) {
  const res = await instance.delete<void>(`/api/users/filters/${userEmail}`, {
    data: filters,
    params: {
      changeLogMessage,
    },
  });
  return res.data;
}

export async function bulkDeleteReports(
  reportIds: number[],
  changeLogMessage: string
) {
  const res = await instance.delete<void>(`/api/reports/bulkDeleteReports`, {
    data: reportIds,
    params: {
      changeLogMessage,
    },
  });
  return res.data;
}

export async function getAllReports() {
  const res = await instance.get<ReportModel[]>(`/api/reports/getAllReports`);
  return res.data;
}

export async function getReports(data: Page<ReportModel[]>) {
  const res = await instance.post<Page<ReportModel[]>>(
    `/api/reports/getReports`,
    data,
    {
      params: {
        pageSize: data.pageSize,
      },
    }
  );

  return res.data;
}

export async function deleteReport(
  reportId: number,
  reportName: string,
  changeLogMessage: string
) {
  const res = await instance.delete<void>(`/api/reports/deleteReport`, {
    params: {
      reportId,
      reportName,
      changeLogMessage,
    },
  });

  return res.data;
}

export async function getAllBulkImports() {
  const res = await instance.get<BulkImportModel[]>(
    `/api/bulkOps/getAllBulkImports`
  );
  return res.data;
}

export async function getBulkImportTypes() {
  const res = await instance.get<BulkImportType[]>(
    `/api/bulkOps/getBulkImportTypes`
  );
  return res.data;
}

export async function deleteBulkOps(bulkOpIds: number[]) {
  const res = await instance.delete<void>(`/api/bulkOps/deleteBulkOps`, {
    data: bulkOpIds,
  });
  return res.data;
}

export async function runBulkOp(
  model: BulkImportModel,
  spreadsheetId: string | null,
  changeLogMessage: string
) {
  const res = await instance.post<string>('/api/bulkOps/runBulkOp', model, {
    params: {
      spreadsheetId,
      changeLogMessage,
    },
  });
  return res.data;
}

export async function getSpreadsheetLines(model: BulkImportModel) {
  const res = await instance.post<SpreadsheetLinesResult>(
    '/api/bulkOps/getSpreadsheetLines',
    model
  );
  return res.data;
}

export async function refreshBulkOp(model: BulkImportModel) {
  const res = await instance.put<string>('/api/bulkOps/refreshBulkOp', model);
  return res.data;
}

export async function generateTemplate(request: TemplateGenerationRequest) {
  const res = await instance.post<{ [key: string]: string }>(
    '/api/bulkOps/template/generate',
    request
  );
  return res.data;
}

export async function createReport(
  model: Partial<ReportModel>,
  changeLogMessage: string
) {
  const res = await instance.post<ReportModel>(
    '/api/reports/createReport',
    model,
    {
      params: {
        changeLogMessage,
      },
    }
  );

  return res.data;
}

export async function getReportTypes() {
  const res = await instance.get<ReportType[]>(`/api/reports/getReportTypes`);
  return res.data;
}

export async function editReport(
  model: Partial<ReportModel>,
  changeLogMessage: string
) {
  const res = await instance.put<ReportModel>(
    '/api/reports/editReport',
    model,
    {
      params: {
        changeLogMessage,
      },
    }
  );
  return res.data;
}

export async function pinReportToDomain(model: Partial<ReportModel>) {
  const res = await instance.put<ReportModel>(
    '/api/reports/pinReportToDomain',
    model
  );
  return res.data;
}

export async function pinReportPersonally(payload: {
  reportId: number;
  action: PinAction;
}) {
  const res = await instance.put<ReportModel>(
    '/api/reports/pinReportPersonally',
    payload
  );
  return res.data;
}

export async function startReport(
  reportModel: Partial<ReportModel>,
  changeLogMessage: string
) {
  const res = await instance.post<ReportModel>(
    `/api/reports/runReport`,
    reportModel,
    {
      params: {
        changeLogMessage,
      },
    }
  );
  return res.data;
}

export async function saveSignature(
  model: Partial<SignatureModel>,
  changeLogMessage: string
) {
  const res = await instance.post<void>(
    `/api/signatures/saveSignature`,
    model,
    {
      params: {
        changeLogMessage,
      },
    }
  );
  return res.data;
}

export async function editSignature(
  model: Partial<SignatureModel>,
  changeLogMessage: string
) {
  const res = await instance.put<number>(
    '/api/signatures/editSignature',
    model,
    {
      params: {
        changeLogMessage,
      },
    }
  );
  return res.data;
}

export async function deleteSignatures(
  signatureIds: number[],
  changeLogMessage: string
) {
  const res = await instance.delete<void>(`/api/signatures/deleteSignatures`, {
    data: signatureIds,
    params: {
      changeLogMessage,
    },
  });
  return res.data;
}

export async function runSignatures(
  models: SignatureModel[],
  changeLogMessage: string
) {
  const res = await instance.post<void>(
    `/api/signatures/runSignatures`,
    models,
    {
      params: {
        changeLogMessage,
      },
    }
  );
  return res.data;
}

export async function getWelcomeTemplates() {
  const res = await instance.post<Page<WelcomeTemplateEntity[]>>(
    `/api/settings`,
    {
      cursor: null,
      results: [],
      nameSpace: '',
      pageSize: 50,
      firstPull: true,
      searchTime: 0,
    },
    {
      params: {
        pageSize: 50,
      },
    }
  );
  return res.data;
}

export async function getApiApps() {
  const res = await instance.get<ApigeeApp[]>(`/api/settings/apiapps`);
  return res.data;
}

export async function createApiApp(
  app: Partial<ApigeeApp>,
  changeLogMessage: string
) {
  const res = await instance.post<void>(`/api/settings/apiapps`, app, {
    params: {
      changeLogMessage,
    },
  });
  return res.data;
}

export async function deleteApiApps(
  appKeys: string[],
  changeLogMessage: string
) {
  const res = await instance.delete<void>(`/api/settings/apiapps`, {
    params: {
      appKeys,
      changeLogMessage,
    },
    paramsSerializer: (params) => {
      return qs.stringify(params, { arrayFormat: 'repeat' });
    },
  });
  return res.data;
}

export async function getApiPortalLink() {
  const res = await instance.get<string>(`/api/settings/apilink`);
  return res.data;
}

export async function saveBulkImport(
  model: Partial<BulkImportModel>,
  changeLogMessage: string
) {
  const res = await instance.post<BulkImportModel>(
    '/api/bulkOps/saveBulkImport',
    model,
    {
      params: {
        changeLogMessage,
      },
    }
  );
  return res.data;
}

export async function getIpIntrusionSettings() {
  const res = await instance.get<IP_Settings>(`/api/settings/ipintrusion`);
  return res.data;
}

export async function updateIpIntrusionStatus(
  isGpanelEnabled: boolean,
  changeLogMessage: string
) {
  const res = await instance.put<IP_Settings>(
    `/api/settings/updateIpIntrusionStatus`,
    null,
    {
      params: {
        isGpanelEnabled,
        changeLogMessage,
      },
    }
  );
  return res.data;
}

export async function updateApiIpIntrusionStatus(
  isApiEnabled: boolean,
  changeLogMessage: string
) {
  const res = await instance.put<IP_Settings>(
    `/api/settings/updateApiIpIntrusionStatus`,
    null,
    {
      params: {
        isApiEnabled,
        changeLogMessage,
      },
    }
  );
  return res.data;
}

export async function addIpIntrusionRule(
  newIpRule: IpIntrusionRule,
  changeLogMessage: string
) {
  const res = await instance.post<IP_Settings>(
    `/api/settings/addIpIntrusionRule`,
    newIpRule,
    {
      params: {
        changeLogMessage,
      },
    }
  );
  return res.data;
}

export async function removeIpIntrusionRules(
  intrusionRules: IpIntrusionRule[],
  changeLogMessage: string
) {
  const res = await instance.delete<void>(
    `/api/settings/removeIpIntrusionRules`,
    {
      data: intrusionRules,
      params: {
        changeLogMessage,
      },
    }
  );
  return res.data;
}

export async function getAllFeatures() {
  const res = await instance.get<FeatureEntity[]>(
    `/api/features/getAllFeatures`
  );
  return res.data;
}

export async function createAdminLabsFeature(feature: FeatureEntity) {
  const res = await instance.post<void>(`/api/features/createFeature`, feature);
  return res.data;
}

export async function updateAdminLabsFeature(feature: FeatureEntity) {
  const res = await instance.put<void>(`/api/features/updateFeature`, feature);
  return res.data;
}

export async function deleteAdminLabsFeature(featureNames: string[]) {
  const res = await instance.delete<void>(`/api/features/deleteFeature`, {
    data: featureNames,
  });
  return res.data;
}

export async function getAllLabsFeatures() {
  const res = await instance.get<FeatureEntity[]>(`/api/labs/getAllFeatures`);
  return res.data;
}

export async function disableFeature(
  feature: string,
  changeLogMessage: string
) {
  const res = await instance.put<void>(`/api/labs/disableFeature`, feature, {
    params: {
      changeLogMessage,
    },
  });
  return res.data;
}

export async function enableFeature(
  featureString: string,
  changeLogMessage: string
) {
  const res = await instance.post<void>(
    `/api/labs/enableFeature`,
    featureString,
    {
      params: {
        changeLogMessage,
      },
    }
  );
  return res.data;
}

export async function saveTimezone(timezone: string, changeLogMessage: string) {
  const res = await instance.post<void>(
    '/api/greeting/saveTimezone',
    timezone,
    {
      params: {
        changeLogMessage,
      },
    }
  );
  return res.data;
}

export async function getTimezone() {
  const res = await instance.get<string>(`/api/greeting/getTimezone`);
  return res.data;
}

export async function setSlackUserToken(
  userToken: string,
  changeLogMessage: string
) {
  await instance.post<void>(
    `/api/slack/user-token`,
    { userToken },
    {
      params: {
        changeLogMessage,
      },
    }
  );
}

export async function getSlackConnection() {
  const res = await instance.get<SlackConnectionStatus>(
    `/api/slack/connection`
  );
  return res.data;
}

export interface SlackChannel {
  id: string;
  name: string;
  is_private?: boolean;
  isPrivate?: boolean;
  private?: boolean;
  numOfMembers?: number;
}

export interface SlackChannelsResponse {
  channels: SlackChannel[];
  response_metadata?: {
    next_cursor?: string;
  };
}

export async function getSlackChannelsPage(cursor?: string) {
  const res = await instance.get<SlackChannelsResponse>(`/api/slack/channels`, {
    params: {
      cursor: cursor || undefined,
      limit: 1000,
    },
  });
  return res.data;
}

export async function getAllSlackChannels() {
  let allChannels: SlackChannel[] = [];
  let nextCursor: string | undefined = undefined;

  do {
    const res = await getSlackChannelsPage(nextCursor);
    if (res.channels) {
      allChannels = allChannels.concat(res.channels);
    }
    nextCursor = res.response_metadata?.next_cursor;
  } while (nextCursor);

  return allChannels;
}

export async function deleteSlackUserToken(changeLogMessage: string) {
  await instance.delete<void>(`/api/slack/user-token`, {
    params: {
      changeLogMessage,
    },
  });
}

export async function getAllPossibleSecondaryDomains() {
  const res = await instance.get<string[]>(
    `/api/settings/possiblesecondarydomains`
  );
  return res.data;
}

export async function getSecondaryDomains() {
  const res = await instance.get<SecondaryDomainModel[]>(
    `/api/settings/secondarydomains`
  );
  return res.data;
}

export async function bulkAddSecondaryDomains(
  domains: string[],
  changeLogMessage: string
) {
  const res = await instance.post<BulkAddSecondaryDomainsResponse>(
    `/api/settings/bulksecondarydomains`,
    domains,
    {
      params: {
        changeLogMessage,
      },
    }
  );
  return res.data;
}

export async function bulkRemoveSecondaryDomains(
  domains: string[],
  changeLogMessage: string
) {
  const res = await instance.delete<void>(
    `/api/settings/bulksecondarydomains`,
    {
      data: domains,
      params: {
        changeLogMessage,
      },
    }
  );
  return res.data;
}

export async function getAllRoles() {
  const res = await instance.get<UserRole[]>(`/api/roles/getAllRoles`);
  return res.data;
}

export function getAllRolesQuery() {
  return queryOptions({
    queryKey: [UserKeys.Roles],
    queryFn: getAllRoles,
    meta: {
      errorMessage: Messages.Errors.Network.Loading('roles'),
    },
  });
}

export interface DriveLabelWithBadgeInfo {
  label: drivelabels_v2.Schema$GoogleAppsDriveLabelsV2Label;
  hasBadge: boolean;
}

export interface DriveLabelListWithBadgeInfoResponse {
  labels: DriveLabelWithBadgeInfo[];
}

export async function getAllDriveLabelsForDriveSearch() {
  const res = await instance.get<DriveLabelListWithBadgeInfoResponse>(
    `/api/labels/listAllLabelsForDriveSearch`
  );
  return res.data;
}

export function getAllDriveLabelsForDriveSearchQuery() {
  return queryOptions({
    queryKey: [UserKeys.DriveLabels],
    queryFn: getAllDriveLabelsForDriveSearch,
    meta: {
      errorMessage: Messages.Errors.Network.Loading('labels'),
    },
  });
}

export async function getAllDriveLabelsForManager() {
  const res = await instance.get<DriveLabelListWithBadgeInfoResponse>(
    `/api/labels/listAllLabelsForManager`
  );
  return res.data;
}

export function getAllDriveLabelsForManagerQuery() {
  return queryOptions({
    queryKey: [UserKeys.DriveLabels],
    queryFn: getAllDriveLabelsForManager,
    meta: {
      errorMessage: Messages.Errors.Network.Loading('labels'),
    },
  });
}

export async function getDriveLabelPermissions(labelId: string) {
  const res = await instance.get<
    drivelabels_v2.Schema$GoogleAppsDriveLabelsV2LabelPermission[]
  >(`/api/labels/${labelId}/permissions`);
  return res.data;
}

export function getDriveLabelPermissionsQuery(labelId: string) {
  return queryOptions({
    queryKey: [UserKeys.DriveLabels, labelId, 'permissions'],
    queryFn: () => getDriveLabelPermissions(labelId),
    enabled: !!labelId,
    meta: {
      errorMessage: Messages.Errors.Network.Loading('label permissions'),
    },
  });
}

export async function getDriveLabelLocks(labelId: string) {
  const res = await instance.get<
    drivelabels_v2.Schema$GoogleAppsDriveLabelsV2LabelLock[]
  >(`/api/labels/${labelId}/locks`);
  return res.data;
}

export function getDriveLabelLocksQuery(labelId: string) {
  return queryOptions({
    queryKey: [UserKeys.DriveLabels, labelId, 'locks'],
    queryFn: () => getDriveLabelLocks(labelId),
    enabled: !!labelId,
    meta: {
      errorMessage: Messages.Errors.Network.Loading('label locks'),
    },
  });
}

export async function createRole(
  newRole: Partial<UserRole>,
  changeLogMessage: string
) {
  const res = await instance.post<UserRole>('/api/roles/createRole', newRole, {
    params: {
      changeLogMessage,
    },
  });
  return res.data;
}

export async function cloneRole(
  newRole: string,
  oldRole: string,
  newRoleDescription: string,
  changeLogMessage: string
) {
  const res = await instance.post<UserRole>('/api/roles/cloneRole', newRole, {
    params: {
      oldRole,
      newRoleDescription,
      changeLogMessage,
    },
  });
  return res.data;
}

export async function deleteRole(
  role: string,
  newRole: string,
  transfer: boolean,
  changeLogMessage: string
) {
  const res = await instance.delete<void>(`/api/roles/deleteRole`, {
    params: {
      role,
      newRole,
      transfer,
      changeLogMessage,
    },
  });
  return res.data;
}
export async function getSessionTimeout() {
  const res = await instance.get<number>(`/api/greeting/getSessionTimeout`);
  return res.data;
}

export async function setSessionTimeout(
  timeout: number,
  changeLogMessage: string
) {
  const res = await instance.put<void>(
    `/api/greeting/setSessionTimeout`,
    null,
    {
      params: {
        timeout,
        changeLogMessage,
      },
    }
  );
  return res.data;
}

export async function doApiCheck(api: string, userToCheck: string | null) {
  const res = await instance.get<boolean>(`/api/admin/doApiCheck`, {
    params: {
      api,
      userToCheck,
    },
  });

  return res.data;
}

export async function getRoleMembers(role: string) {
  const res = await instance.get<RoleMember[]>(`/api/roles/getRoleMembers`, {
    params: {
      role,
    },
  });
  return res.data;
}

export async function addRoleMembers(
  roleMember: RoleMember[],
  changeLogMessage: string
) {
  const res = await instance.post<BulkOperationResponse>(
    `/api/roles/updateRoleMembers`,
    roleMember,
    {
      params: {
        changeLogMessage,
      },
    }
  );
  return res.data;
}

export async function deleteRoleMembers(
  roleMembers: RoleMember[],
  changeLogMessage: string
) {
  const res = await instance.delete<void>(`/api/roles/deleteRoleMembers`, {
    data: roleMembers,
    params: {
      changeLogMessage,
    },
  });
  return res.data;
}

export async function checkRoleMembership(
  userEmail: string,
  memberType?: RoleMemberType
) {
  const res = await instance.get<string>(`/api/roles/checkRoleMembership`, {
    params: {
      userEmail,
      memberType,
    },
  });
  return res.data;
}

export async function updateRole(newRole: UserRole, changeLogMessage: string) {
  const res = await instance.put<UserRole>(`/api/roles/updateRole`, newRole, {
    params: {
      changeLogMessage,
    },
  });
  return res.data;
}

export async function updateRoleSettings(
  newRole: UserRole,
  changeLogMessage: string
) {
  const res = await instance.put<UserRole>(
    `/api/roles/updateRoleSettings`,
    newRole,
    {
      params: {
        changeLogMessage,
      },
    }
  );
  return res.data;
}

export async function renameRole(
  oldRoleName: string,
  newRoleName: string,
  changeLogMessage: string
) {
  const res = await instance.put<UserRole>(
    `/api/roles/renameRole`,
    oldRoleName,
    {
      params: {
        newRoleName,
        changeLogMessage,
      },
    }
  );
  return res.data;
}

export async function renameRoleForEnterprise(
  oldRoleName: string,
  newRoleName: string,
  changeLogMessage: string
) {
  const res = await instance.put<void>(
    `/api/roles/renameRoleForEnterpriseTier`,
    oldRoleName,
    {
      params: {
        newRoleName,
        changeLogMessage,
      },
    }
  );
  return res.data;
}

export async function createWelcomeTemplate(
  model: Partial<WelcomeTemplateEntity>,
  changeLogMessage: string
) {
  const res = await instance.post<WelcomeTemplateEntity>(
    `/api/settings/createWelcomeTemplate`,
    model,
    {
      params: {
        changeLogMessage,
      },
    }
  );
  return res.data;
}

export async function updateWelcomeTemplate(
  model: Partial<WelcomeTemplateEntity>,
  changeLogMessage: string
) {
  const res = await instance.put<WelcomeTemplateEntity>(
    '/api/settings/updateWelcomeTemplate',
    model,
    {
      params: {
        changeLogMessage,
      },
    }
  );
  return res.data;
}

export async function deleteWelcomeTemplate(
  model: WelcomeTemplateEntity,
  changeLogMessage: string
) {
  const res = await instance.delete<void>(
    '/api/settings/deleteWelcomeTemplate',
    {
      data: model,
      params: {
        changeLogMessage,
      },
    }
  );
  return res.data;
}

export async function bulkDeleteWelcomeTemplates(
  selectedWelcomeTemplates: WelcomeTemplateEntity[],
  changeLogMessage: string
) {
  const res = await instance.delete<void>(
    `/api/settings/bulkDeleteWelcomeTemplates`,
    {
      data: selectedWelcomeTemplates,
      params: {
        changeLogMessage,
      },
    }
  );
  return res.data;
}

export async function getResourceDefaultModel() {
  const res = await instance.get<ResourceCalendarDefault>(
    `/api/resourceCalendars/getResourceDefaultModel`
  );
  return res.data;
}

export async function updateDefaultDomain(
  data: Partial<ResourceCalendarDefault>,
  changeLogMessage: string
) {
  const res = await instance.put<ResourceCalendarDefault>(
    `/api/resourceCalendars/updateDefault`,
    data,
    { params: { changeLogMessage } }
  );
  return res.data;
}

export async function getAllUsersCount() {
  const res = await instance.get<number>(`/api/indexing/countAllUsers`);
  return res.data;
}

export async function getUserCountByDomain(domain: string) {
  const res = await instance.get<number>(
    `/api/indexing/countUsersByDomain/${domain}`
  );
  return res.data;
}

export async function getAllUsersCountBigQuery() {
  const res = await instance.get<number>(`/api/indexing/countAllUsersBigQuery`);
  return res.data;
}

export async function getUserCountByDomainBigQuery(domain: string) {
  const res = await instance.get<number>(
    `/api/indexing/countUsersByDomainBigQuery/${domain}`
  );
  return res.data;
}

export async function getAllGroupsCount() {
  const res = await instance.get<number>(`/api/indexing/countAllGroups`);
  return res.data;
}

export async function getAllCalendarsCount() {
  const res = await instance.get<number>(`/api/indexing/countAllCalendars`);
  return res.data;
}

export async function getAllOrgsCount() {
  const res = await instance.get<number>(`/api/indexing/countAllOrgs`);
  return res.data;
}

export async function getUserIndexLogsForDomain(domain: string) {
  const res = await instance.get<IndexUserLog[]>(
    `/api/indexing/getUserIndexLogsForDomain/${domain}`,
    {
      params: {
        limit: 5,
      },
    }
  );
  return res.data;
}

export async function getGroupIndexLogsForDomain(domain: string) {
  const res = await instance.get<IndexGroupLog[]>(
    `/api/indexing/getGroupIndexLogsForDomain/${domain}`,
    {
      params: {
        limit: 5,
      },
    }
  );
  return res.data;
}

export async function getCalendarIndexLogs() {
  const res = await instance.get<IndexCalendarLog[]>(
    `/api/indexing/getCalendarIndexLogs`,
    {
      params: {
        limit: 5,
      },
    }
  );
  return res.data;
}

export async function getOrgIndexLogs() {
  const res = await instance.get<IndexOrgLog[]>(
    `/api/indexing/getOrgIndexLogs`,
    {
      params: {
        limit: 5,
      },
    }
  );
  return res.data;
}

export async function indexAllUsers(changeLogMessage: string) {
  const res = await instance.post<void>(
    `/api/indexing/indexAllUsers`,
    changeLogMessage
  );
  return res.data;
}

export async function indexAllUsersBigQuery(changeLogMessage: string) {
  const res = await instance.post<void>(
    `/api/users/indexAllUsersBigQuery`,
    changeLogMessage
  );
  return res.data;
}

export async function indexUsersByDomain(
  domain: string,
  changeLogMessage: string
) {
  const res = await instance.post<void>(
    `/api/indexing/indexUsersByDomain/${domain}`,
    changeLogMessage
  );
  return res.data;
}

export async function indexUsersByDomainBigQuery(
  domain: string,
  changeLogMessage: string
) {
  const res = await instance.post<void>(
    `/api/indexing/indexUsersByDomainBigQuery/${domain}`,
    changeLogMessage
  );
  return res.data;
}

export async function indexAllGroups(changeLogMessage: string) {
  const res = await instance.post<void>(
    `/api/indexing/indexAllGroups`,
    changeLogMessage
  );
  return res.data;
}

export async function indexAllGroupsBigQuery(changeLogMessage: string) {
  const res = await instance.post<void>(
    `/api/groups/indexAllGroupsBigQuery`,
    changeLogMessage
  );
  return res.data;
}

export async function indexAllCalendars(changeLogMessage: string) {
  const res = await instance.post<void>(
    `/api/indexing/indexAllCalendars`,
    changeLogMessage
  );
  return res.data;
}

export async function indexAllOrgs(changeLogMessage: string) {
  const res = await instance.post<void>(
    `/api/indexing/indexAllOrgs`,
    changeLogMessage
  );
  return res.data;
}

export async function deleteOrIndexUser(
  userEmail: string,
  changeLogMessage: string
) {
  const res = await instance.post<string>(
    `/api/indexing/deleteOrIndexUser/${userEmail}`,
    changeLogMessage
  );
  return res.data;
}

export async function deleteOrIndexGroup(
  groupEmail: string,
  changeLogMessage: string
) {
  const res = await instance.post<string>(
    `/api/indexing/deleteOrIndexGroup/${groupEmail}`,
    changeLogMessage
  );
  return res.data;
}

export async function getAllDecomModels() {
  const res = await instance.get<DecomModel[]>(`/api/decom/getDecomModels`);
  return res.data;
}

export async function deleteDecomModels(
  ids: string[],
  changeLogMessage: string
) {
  const res = await instance.delete<void>(`/api/decom/deleteDecomModels`, {
    data: ids,
    params: {
      changeLogMessage,
    },
  });
  return res.data;
}

export async function runDecomModels(ids: string[], changeLogMessage: string) {
  const res = await instance.post<void>(`/api/decom/runDecomModels`, ids, {
    params: {
      changeLogMessage,
    },
  });
  return res.data;
}

export async function enableDecomModels(
  ids: string[],
  changeLogMessage: string
) {
  const res = await instance.put<void>(`/api/decom/enableDecomModels`, ids, {
    params: {
      changeLogMessage,
    },
  });
  return res.data;
}

export async function disableDecomModels(
  ids: string[],
  changeLogMessage: string
) {
  const res = await instance.put<void>(`/api/decom/disableDecomModels`, ids, {
    params: {
      changeLogMessage,
    },
  });
  return res.data;
}

export async function createDecomPolicy(
  model: DecomModel,
  changeLogMessage: string
) {
  const res = await instance.post<void>(`/api/decom/createDecomPolicy`, model, {
    params: {
      changeLogMessage,
    },
  });
  return res.data;
}

export async function editDecomPolicy(
  model: DecomModel,
  changeLogMessage: string
) {
  const res = await instance.put<void>(`/api/decom/editDecomPolicy`, model, {
    params: {
      changeLogMessage,
    },
  });
  return res.data;
}

export async function getDecomSuspendedUsers() {
  const res = await instance.get<DecomSuspendedUserModel[]>(
    `/api/decom/suspendedUsers`
  );
  return res.data;
}

export async function getAllMarketingOverviewsReact() {
  const res = await instance.get<MarketingOverviewModel[]>(
    `/api/marketing/getAllMarketingOverviewsReact`
  );
  return res.data;
}

export async function deleteSuspendedUsers(
  decomSuspendedUsers: DecomSuspendedUserModel[],
  removeLogs: boolean,
  changeLogMessage: string
) {
  const res = await instance.delete<void>(`/api/decom/deleteSuspendedUsers`, {
    data: decomSuspendedUsers,
    params: {
      removeLogs,
      changeLogMessage,
    },
  });
  return res.data;
}

export async function pauseDecomUsers(
  decomSuspendedUsers: DecomSuspendedUserModel[],
  changeLogMessage: string
) {
  const res = await instance.put<void>(
    `/api/decom/pauseDecomUsers`,
    decomSuspendedUsers,
    {
      params: {
        changeLogMessage,
      },
    }
  );
  return res.data;
}

export async function unpauseDecomUsers(
  decomSuspendedUsers: DecomSuspendedUserModel[],
  changeLogMessage: string
) {
  const res = await instance.put<void>(
    `/api/decom/unpauseDecomUsers`,
    decomSuspendedUsers,
    {
      params: {
        changeLogMessage,
      },
    }
  );
  return res.data;
}

export async function terminateDecomUsers(
  decomSuspendedUsers: DecomSuspendedUserModel[],
  changeLogMessage: string
) {
  const res = await instance.put<void>(
    `/api/decom/terminateDecomUsers`,
    decomSuspendedUsers,
    {
      params: {
        changeLogMessage,
      },
    }
  );
  return res.data;
}

export async function getDecomLogs(
  body: Page<DecomLogModel[]>,
  suspendedUserModelId: string | null,
  acknowledged: boolean | null
) {
  const res = await instance.post<Page<DecomLogModel[]>>(
    `/api/decom/decomLogs`,
    body,
    {
      params: { suspendedUserModelId, acknowledged },
    }
  );
  return res.data;
}

export async function updateMarketingOverview(
  model: Partial<MarketingOverviewModel>
) {
  const res = await instance.post<void>(
    `/api/marketing/updateMarketingOverview`,
    model
  );
  return res.data;
}

export async function hideMarketingBar() {
  const res = await instance.post<void>(`/api/marketing/hideMarketingBar`);
  return res.data;
}

export async function resetAllMarketingModels() {
  const res = await instance.post<void>(
    `/api/marketing/resetAllMarketingModels`
  );
  return res.data;
}

export async function canAccessView() {
  const res = await instance.get<boolean>(`/api/greeting/canAccessView`);
  return res.data;
}

export const canAccessViewQuery = (emailDomain: string) =>
  queryOptions({
    queryKey: [UserKeys.AdminView],
    queryFn: () => canAccessView(),
    enabled: emailDomain.includes('promevo.com'),
  });

export async function deleteMarketingOverviews(ids: number[]) {
  const res = await instance.delete<void>(
    `/api/marketing/deleteMarketingOverviews`,
    {
      data: ids,
    }
  );
  return res.data;
}

export async function getTrialUserEmails() {
  const res = await instance.get<string[]>(`/api/greeting/getTrialUserEmails`);
  return res.data;
}

export async function saveTrialUsers(users: TrialUserModel[]) {
  const res = await instance.post<void>(`/api/greeting/saveTrialUsers`, users);
  return res.data;
}

export async function indexTrialUsers() {
  const res = await instance.post<void>(`/api/indexing/indexTrialUsers`);
  return res.data;
}

export async function completeLogs(logs: DecomLogModel[]) {
  const res = await instance.put<void>(`/api/decom/completeLogs`, logs);
  return res.data;
}

export async function acknowledgeLogs(logs: DecomLogModel[]) {
  const res = await instance.put<void>(`/api/decom/acknowledgeLogs`, logs);
  return res.data;
}

export async function addAllUsersToGroup(
  groupEmail: string,
  role: string,
  changeLogMessage: string
) {
  const res = await instance.post<void>(
    `/api/groups/addAllUsersToGroup`,
    null,
    {
      params: {
        groupEmail,
        role,
        changeLogMessage,
      },
    }
  );
  return res.data;
}

export async function createUserLoggedInLog() {
  const res = await instance.post<void>(`/api/greeting/createUserLoggedInLog`);
  return res.data;
}

export async function createAdminLoggedInLog() {
  const res = await instance.post<void>(`/api/greeting/createAdminLoggedInLog`);
  return res.data;
}

export async function getSharedDrivesByIds(sharedDriveIds: string[]) {
  const res = await instance.post<SharedDriveModel[]>(
    `/api/shared-drives/getSharedDrivesByIds`,
    sharedDriveIds
  );
  return res.data;
}

export function getSharedDrivesByIdsQuery(sharedDriveIds: string[]) {
  return queryOptions({
    queryKey: [UserKeys.SharedDrive, sharedDriveIds],
    queryFn: () => getSharedDrivesByIds(sharedDriveIds),
    meta: {
      errorMessage: Messages.Errors.Network.Loading('shared drives'),
    },
  });
}

export async function saveScheduledUserStatusUpdate(
  request: Partial<ScheduledUserStatusUpdate>,
  changeLogMessage: string
) {
  const res = await instance.post<void>(
    '/api/users/scheduledUserStatusUpdate',
    request,
    {
      params: {
        changeLogMessage,
      },
    }
  );
  return res.data;
}

export async function getScheduledUserStatusUpdate(userEmail: string) {
  const res = await instance.get<ScheduledUserStatusUpdate>(
    `/api/users/scheduledUserStatusUpdate/${userEmail}`
  );
  return res.data;
}

export async function deleteScheduledUserStatusUpdate(
  userEmail: string,
  changeLogMessage: string
) {
  const res = await instance.delete<void>(
    `/api/users/scheduledUserStatusUpdate/${userEmail}`,
    {
      params: {
        changeLogMessage,
      },
    }
  );
  return res.data;
}
